import React from 'react'
import relationshipsIntroAnimation from "assets/animation/relationships-intro-animation.json";
import Lottie from "lottie-react";
import StyledAnimationWrapper from "components/styled/AnimationWrapper.styled";
import StyledBackgroundWrapper from "components/styled/BackgroundWrapper.styled";

const SvgRelationshipIntro = () => {
  return (
    <StyledBackgroundWrapper>
    <StyledAnimationWrapper top="5%" left="15%" width="45%">
      <Lottie animationData={relationshipsIntroAnimation} loop={true} autoPlay={true} />
    </StyledAnimationWrapper>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 960 1080">
    <defs>
      <clipPath id="a">
        <path
          d="M331 709c-2.6 7-25.6 4.8-27.3-2.3-.7-3.1.3-5.9 1.9-8.6 2-3.4 2.4-6.9 3.3-10.2 1.1-4 5.9-7 10.4-6.5 4.1.5 8 4.6 8.3 9.1.2 3.5.4 4.5 2.1 9.1 1.1 3.3 2.7 5.7 1.3 9.4Z"
          fill="none"
        />
      </clipPath>
      <clipPath id="c">
        <path
          d="M570.3 474.8a64.59 64.59 0 0 1-9.8 1.6c-4 .2-10.6-.1-10.6-.1a58.31 58.31 0 0 0-2.2 7.1c-3.8-5.6-14.9-22.8-16.8-35-.6-3.8 3.9-8.1 3.9-15.7 0-2.5.4-5-1-7.5-4.1-7.9-16.2-12.2-17.3-11.1-.9.9.8 2.1.8 2.1-.8-.3-2.5-.9-3-.3-.9 1.2 1.3 2.8 3 4.6 2 2.1 3.5 3.9 3.3 4.1-.3.5-9.2-3.8-10-2.7s.4 2.4.4 2.4c-.8.1-1.5.5-1.2 1.5s3.2 3 6.9 5.7a8.17 8.17 0 0 1 3.3 5.5c.5 3-1.3 4.2-1.3 7.5 0 3 1.8 5.1 2.2 6.1 2.7 7.1 11.2 62.2 24.5 64.8 11.6 2.2 23.6-16.9 24.9-40.6Z"
          fill="none"
        />
      </clipPath>
      <clipPath id="e">
        <path
          d="m257.2 754.1-4.6-25.9-1.5-8.4h-73.5s-4.3 27.6-4.8 37.6a25.85 25.85 0 0 0 24.6 27.1h34.3a25.91 25.91 0 0 0 25.9-25.9 17.15 17.15 0 0 0-.4-4.5Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="b"
        data-name="SVGID 4"
        width={131}
        height={104}
        patternTransform="translate(-1864 17114.55)"
        patternUnits="userSpaceOnUse"
      >
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="#13a89e" d="M0 0h131v104H0z" />
      </pattern>
      <pattern
        id="d"
        data-name="SVGID 7"
        width={131}
        height={104}
        patternTransform="translate(-1387 17118.55)"
        patternUnits="userSpaceOnUse"
      >
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="none" d="M0 0h131v104H0z" />
        <path fill="#fbaa2c" d="M0 0h131v104H0z" />
      </pattern>
    </defs>
    <path
      d="M960.9 1.2-.9 1l.4 1007.4 7.3-6.7 1.5-1.3q18.6-18.31 36.62-34.83c249.71-225 424.13-206.52 544.24-222.78a314.65 314.65 0 0 0 41-7.49c56.3-14.7 166.5-81.4 193.9-132.4.5-1-.4 1.3.1.4 15.9-30.9 22.2-69.5 16.1-103.7C781 169.6 960.9 1.2 960.9 1.2Z"
      fill="#ffeab0"
      data-name="Layer 2"
    />
    <g data-name="Layer 4">
      <path
        d="M833.9 539.6c0 1 0 2-.1 3-1 2.9-.6 6-.8 9-.4 8.3-1.5 16.6-1.8 24.9a16.48 16.48 0 0 1-.4 3.2l-3.7 42.7c-1.3 4.3-2.2 8.7-4 12.9-5.1 11.5-13.7 19.2-25.3 23.6a3.88 3.88 0 0 0-1.1.6c-5.4.9-10.7 2.2-16.1 2.8-4 .4-8 0-11.9.3H297.9c-2.8 0-5.6-.1-8.4-.1-7.3 0-14.5.1-21.8.2-2.2 0-4.4 0-6.6-.1-2.4-.1-4.9.2-7.3-.3-4.8-1-9.5-1.9-14.3-2.8-4.7-2.2-9.5-4.3-13.7-7.6a44 44 0 0 1-14.8-22.5c-.8-2.5-1.3-5-2-7.5-.1-.8-.1-1.7-.2-2.5-.3-3.7-.6-7.3-.9-11-.6-8.4-1.1-16.8-2.1-25.1l-.4-3c.5-2.2 0-4.3-.2-6.4-.5-8.7-1.1-17.3-2.1-25.9-.2-1.9-.4-3.9-.5-5.8v-1.5a41 41 0 0 1 .1-10.5c.6-6 4.3-10.3 9.9-10.8a60.65 60.65 0 0 1 20.8 1.5c-.1 5.6.8 11.1 1.2 16.6.4 6.6 1.3 13.2 1.9 19.8.6 6.9.9 13.8 1.7 20.6.3 2.3-.3 5 1.4 7.1.2 8.5-.6 16.9.5 25.4-1.2 1.3-.1 2.7.1 3.8 1 5.4 2.5 10.6 7.8 13.5a23.35 23.35 0 0 0 11 2.5h423.6c31.6 0 63.1.1 94.7-.1 11.5-.1 18.2-4.9 19.6-17.1.2-2 1.2-4.1.2-6.2v-20.9a18.15 18.15 0 0 0 1-6.1c.1-6.9 1.2-13.7 1.6-20.6.5-7.2 1.3-14.4 1.9-21.6l1.5-16.8c8.9-1.8 17.7-3.3 26.4.6a1 1 0 0 0 1 .9c3.9 5.3 3.5 11.4 3.4 17.3Z"
        fill="#adc2ce"
      />
      <path
        d="M775.3 702.3a27.61 27.61 0 0 0 .6 4c.5 1.7 0 2-1.7 2.2-4.1.5-7.2-.5-8.8-4.6a14.79 14.79 0 0 0-1.3-2.1L752.3 684c-.8-1.3-1.6-2.6-2.5-3.8-4.1-5.6-8.3-11.2-11.3-17.5h30.2L772 682c.8 6.8 2.1 13.5 3.3 20.3Z"
        fill="#8e4910"
      />
      <path
        d="M797.2 585.9v20.9c-.2.5-.3 1-.5 1.5a23.7 23.7 0 0 1-7.1 12.8c-5.7 5.3-12.6 7.5-20.2 7.5H531.5c-6.6-.3-10.7-4.3-10.8-10.7-.1-11.5 0-23 0-34.5h275Z"
        fill="#bccdd8"
      />
      <path
        d="M520.7 583.3c0 11.5-.1 23 0 34.5 0 6.4 4.2 10.4 10.8 10.7 1.3.1 2.7 0 4.1 0h233.8c7.6 0 14.5-2.2 20.2-7.5a23.86 23.86 0 0 0 7.2-12.8 8.8 8.8 0 0 1 .5-1.5c1 2.1.1 4.2-.2 6.2-1.5 12.2-8.1 17-19.6 17.1-31.6.2-63.1.1-94.7.1H259.2a22.21 22.21 0 0 1-11-2.5c-5.4-2.9-6.8-8.1-7.8-13.5-.2-1.2-1.3-2.5-.1-3.8 3.9 11.5 13.9 18.2 26 18.2q119.85.15 239.8.1a20.8 20.8 0 0 0 5-.7c4.7-1.2 7.2-4.3 7.2-9.2.1-11.8 0-23.5 0-35.3l.1-2h2.4a12.1 12.1 0 0 0-.1 1.9Z"
        fill="#939fa5"
      />
    </g>
    <g data-name="Layer 1">
      <path
        d="M780 492.8c-.1 2.5-.1 5.1-.2 7.6a1.79 1.79 0 0 0-.4 1.4c.5 8.8-1.4 17.4-1.1 26.1-.2 4.2-.3 8.4-.5 12.6-.5 9-1 18-1.5 26.9-3.1-.9-5.8-2.5-9-3.3-1.2-.3-2.1-.2-2.2 1.2a15 15 0 0 1-1.5 5.1c-1 2.8-1.9 3.4-4.6 2.7-8.5-2.3-17-4.7-25.6-6.9-3.8-1-7.7-1.8-11.6-2.7-4.4-1-8.7-2.3-13.3-2.7a4.76 4.76 0 0 1-.3-3.7c2 .4 4.1.8 6.2 1.3 8.2 1.9 16.4 3.8 24.6 5.8 6.7 1.7 13.4 3.6 20 5.5 2.3.7 3.8.3 4.3-2.3.2-1 .7-1.9.9-2.9 1.8-9.8 3.6-19.6 6.1-29.2 1.6-6.3 3.4-12.5 5.1-18.7a36.9 36.9 0 0 0 2.4-8 3.66 3.66 0 0 0-2.8-4.3h-.2c-3.6-.6-7.1-1.3-10.7-2-8.3-1.7-16.4-3.7-24.6-5.8-8.7-2.2-17.2-4.6-25.9-6.9-2-.5-3.4-.1-4.2 2a25.42 25.42 0 0 0-1.6 8.2 7 7 0 0 0-3.2-.6c-4.2 0-8.5.4-12.7.5-11 .2-22 .1-33.1.1-5.9 0-11.8-.3-17.8-.5-1.5 0-2.8.2-3.1 1.9a22.46 22.46 0 0 0-.6 6.3c.5 6.7 1.2 13.3 1.3 20a327.76 327.76 0 0 1-1 32.9h-86.3a50.18 50.18 0 0 0-18.7 4 20.94 20.94 0 0 0-8.9 6.1 14.32 14.32 0 0 0-3.2 10.9h-2.4c.8-6.5-2.5-11.2-7.5-14.5-6.6-4.3-14.2-5.9-21.9-6.3-8.3-.4-16.6-.1-24.9-.1-1.2 0-2.4.2-2.6 1.5-.3 2.1-2 2.2-3.4 2.5-2.7.4-5.4.4-8.1.6-4 .4-8 .7-12.1 1.3-6.7.9-13.4 1.8-20 2.8s-13 1.9-19.5 2.9c-2.7.4-5.3 1.6-7.5-1.1a1.61 1.61 0 0 0-.9-.3c-2.3-.2-4.5-.5-6.8-.5h-32.6c-6.1 0-12.1.8-18.3.5-3.7-.1-4-.3-4-4.1v-1c3.1 1.8 6.4 1.1 9.7.6h49.6c1.2 0 2.5.8 3.6-.3.5 2.1 1.6 3.2 4 2.8 4.1-.8 8.3-1.4 12.4-2.1q25.05-4.05 50.4-6.3c2.3-.2 3.4-1.3 3.3-3.6a18.41 18.41 0 0 0-.3-3.3c-2-9.7-3.9-19.4-5.1-29.2-1-9.1-1.8-18.2-2.8-27.3-.3-3.1-1.5-4.1-4.5-3.5-8.6 1.8-17.3 3-26.1 4.3-8.1 1.1-16.2 2.4-24.5 2.8-.7-1.1-1.8-1.1-2.9-1-4.5.2-9 .3-13.4.4-16.1.3-32.3.5-48.4-.5 1.3-4.8-1.8-6.6-5.1-5.6a15.94 15.94 0 0 1-3 .6c-7.4.6-14.8 1.5-22.1 2.3-11.9 1.2-23.7 1.8-35.6 2.3-3.3.1-3.8.7-4.1 4.1-.4 5.5 1 10.7 1.8 16.1 1.2 8.2 1.7 16.4 2.3 24.6.5 6.5.6 13 1 19.5.1 1.8.9 3 2.8 2.9 2.2-.2 4.3-.6 6.5-.9a13.8 13.8 0 0 1 2-.3c12.8-1.1 25.7-2.4 38.5-3.3 3.3-.2 6.8.4 9.9-1.2v4.8c-4.5.3-9.1.7-13.6 1-5.2.4-10.4.6-15.6 1.1-8.9 1-17.8 1.5-26.6 2.9-2.9.5-4-.5-4.2-3.5-.1-1.5-.8-1.6-2-1.1-2 .8-4.1 1.4-6.2 2.2-.5-12.5-1-24.9-1.6-37.3a21.66 21.66 0 0 0-.4-2.5c.3-5.9-.4-11.8-.6-17.7-.4-11.3-1.2-22.5-1.9-33.8h525.7l-.4 7.6v1c0 1.7-.1 3.4-.1 5.1a2.85 2.85 0 0 0-.4 2.5Zm-177.9 24.9c-1.8.1-3.2.1-4.7.2-.5.1-1.2.3-1.3 1s.7.7 1.3.9c2.2.8 4.5.3 6.8.4 2.5.1 5.1 2.7 5 5.1a51.45 51.45 0 0 0 .1 6.8c0 .7.2 1.5 1 1.6s.8-.8 1-1.5a33 33 0 0 0 .5-7 5.19 5.19 0 0 1 4.9-4.9c2.5-.1 4.9.3 7.3-.5.4-.2.9-.3.9-.8s-.4-.6-.8-.8a17.45 17.45 0 0 0-6-.5c-4.5 0-6.2-1.7-6.2-6.2a51.08 51.08 0 0 0-.5-5.5c-.1-.8 0-1.7-1-1.8s-1 1-1 1.7v6.9a2.63 2.63 0 0 1-.6 2.1c-2 2-3.9 3.9-6.7 2.8Zm-85.3 8.2c.5 1.9.2 4 .3 6.1 0 .6.2 1.3.9 1.3s.8-.6.9-1.1a17.34 17.34 0 0 0 .7-6c0-3.9 1.9-5.9 6-5.9a20.21 20.21 0 0 0 6.5-.5c.5-.2 1-.3.9-1s-.6-.4-1-.5a20.32 20.32 0 0 0-6-.5c-4.7 0-6.5-1.7-6.4-6.4 0-1.7-.5-3.3-.5-5 0-.7-.1-1.5-1-1.5s-1 1-1 1.7v6.4a2.63 2.63 0 0 1-.6 2.1c-1.8 2.1-3.9 3.5-6.9 2.8-1.7-.4-3.3.4-5 .5-.5 0-1.1.1-1.1.8s.6.6 1.1.8c2.3.8 4.7.4 7.1.5a5.06 5.06 0 0 1 5 5.2c.1-.1.1 0 .1.2Z"
        fill="#abc0ca"
      />
      <path
        d="M240.1 610.3c-1.1-8.4-.3-16.9-.5-25.4l1-1.6H518c0 11.8.1 23.6 0 35.3 0 4.9-2.6 8-7.2 9.2a20.8 20.8 0 0 1-5 .7q-119.85 0-239.8-.1c-12 .1-22-6.7-25.9-18.1Z"
        fill="#bccdd8"
      />
      <path
        d="m797.2 585.9-1.5-2.5a8.77 8.77 0 0 0-2.3-4.1c-4.7-5.3-10.8-8.6-17-11.7.5-9 1-18 1.5-26.9.2-4.2.4-8.4.5-12.6 2.8-.1 5.1-1.6 7.7-2.4 5.7-1.7 11.4-3.7 17.3-4.8l-1.5 16.8c-.7 7.2-1.5 14.4-1.9 21.6-.4 6.9-1.5 13.7-1.6 20.6a26.59 26.59 0 0 1-1.2 6ZM233.5 520.8a209.55 209.55 0 0 1 21.8 6.5 26.81 26.81 0 0 0 2.7.7 17.42 17.42 0 0 1 .5 2.2c.5 12.4 1.1 24.9 1.6 37.3-3.4 2-7.1 3.6-10.3 5.9-3.7 2.7-7.4 5.3-9.1 9.8l-1 1.6c-1.7-2.1-1.1-4.7-1.4-7.1-.8-6.8-1.1-13.7-1.7-20.6-.6-6.6-1.5-13.2-1.9-19.8-.4-5.4-1.3-10.9-1.2-16.5Z"
        fill="#94aebc"
      />
      <path
        d="M297.9 662.6c-2.1 4.3-5 8-7.6 12-5 7.7-10.1 15.4-15.1 23-.9 1.3-1.7 2.7-2.5 4a9.74 9.74 0 0 0-1.5 2.4c-1.7 4-4.7 4.9-8.7 4.5-1.6-.2-2.2-.7-1.8-2.2a13.42 13.42 0 0 0 .4-3.5c1.4-6.9 2.6-13.9 3.5-20.9 1.1-6.4 2.1-12.8 3.2-19.2 7.3-.1 14.5-.1 21.8-.2 2.7 0 5.5.1 8.3.1Z"
        fill="#8e4910"
      />
      <path
        d="M520.7 583.3c0-.7-.1-1.3-.1-2a14.32 14.32 0 0 1 3.2-10.9 22.88 22.88 0 0 1 8.9-6.1 50.18 50.18 0 0 1 18.7-4h86.3c.2 1.7-.9 3.4.1 5.1-.7 2.4.3 4 2.7 4.1 4.3 0 8.6-.3 12.9-.4q19.8-.45 39.6 0c4 .1 8.1.4 12.1.4 2.6 0 3.7-1.6 2.9-4.1a18.16 18.16 0 0 1 .6-4.6c4.5.3 8.9 1.6 13.3 2.7 3.8.9 7.7 1.7 11.6 2.7 8.6 2.2 17.1 4.6 25.6 6.9 2.7.7 3.7.1 4.6-2.7a17.67 17.67 0 0 0 1.5-5.1c0-1.4.9-1.5 2.2-1.2 3.2.7 5.9 2.4 9 3.3 6.2 3.1 12.3 6.4 17 11.7a8.41 8.41 0 0 1 2.3 4.1ZM518.2 581.3l-.1 2H240.6c1.7-4.5 5.4-7.2 9.1-9.8 3.2-2.3 6.9-3.9 10.3-5.9 2.1-.7 4.2-1.4 6.2-2.2 1.2-.5 1.8-.4 2 1.1.3 3 1.3 4 4.2 3.5 8.8-1.4 17.7-1.9 26.6-2.9 5.2-.6 10.4-.8 15.6-1.1 4.5-.3 9.1-.7 13.6-1v1.5c0 3.8.3 4 4 4.1 6.1.2 12.2-.6 18.3-.5h32.6c2.3 0 4.5.3 6.8.5a1.4 1.4 0 0 1 .9.3c2.2 2.7 4.8 1.5 7.5 1.1 6.5-1.1 13-2 19.5-2.9 6.7-1 13.3-1.9 20-2.8 4-.5 8-.9 12.1-1.3 2.7-.2 5.4-.3 8.1-.6 1.4-.2 3.1-.4 3.4-2.5.2-1.3 1.4-1.5 2.6-1.5 8.3 0 16.6-.3 24.9.1 7.7.4 15.4 2 21.9 6.3 4.9 3.3 8.2 8 7.4 14.5Z"
        fill="#cbd9e2"
      />
      <path
        d="M637.8 565.5c-1-1.7.2-3.4-.1-5.1.9-11 1.2-22 1-32.9-.2-6.7-.8-13.3-1.3-20a22.46 22.46 0 0 1 .6-6.3c.3-1.6 1.6-1.9 3.1-1.9 5.9.2 11.8.5 17.8.5 11 .1 22 .1 33.1-.1 4.2-.1 8.5-.4 12.7-.5a7 7 0 0 1 3.2.6l.3 1.5a5.72 5.72 0 0 0 0 5.1 17 17 0 0 1-.2 4.5c-1.2.5-2.3 1.3-3.5 1.3-6-.2-10.8 3-15.8 5.3-3.3 1.5-6.1 4.1-9.4 5.6a11.54 11.54 0 0 0-2.9 2c-4.3 4.2-8.5 8.6-12.9 12.8-1.9 1.8-3 4.1-4.7 6.1-2.7 3.1-4.6 6.8-6.5 10.3s-5.2 7-5.2 11.6c-3.2.7-6.3 1.5-9.3-.4Z"
        fill="#f6f4e1"
      />
      <path
        d="M277.8 565.1c-2.2.3-4.3.8-6.5.9-1.9.1-2.7-1.1-2.8-2.9-.3-6.5-.5-13-1-19.5-.6-8.2-1.1-16.5-2.3-24.6-.8-5.3-2.2-10.6-1.8-16 .2-3.3.8-3.9 4.1-4.1 11.9-.5 23.8-1.1 35.6-2.3 7.4-.8 14.8-1.7 22.1-2.3a15.94 15.94 0 0 0 3-.6c3.3-1 6.4.8 5.1 5.6-4.8.2-4.8.2-5.2 5-.1 1.1-.2 2.2-.3 3.2a30 30 0 0 0-9.2 3.9c-4 2.5-8.1 4.9-11.6 8.1-4.3 4-8.7 7.9-12.1 12.6-5.1 7-10 14.2-13.2 22.3-1.4 3.6-3.9 6.7-3.9 10.7Z"
        fill="#ebb452"
      />
      <path
        d="M647 566.1c0-4.6 3.2-7.8 5.2-11.5s3.8-7.2 6.5-10.3c1.7-1.9 2.8-4.3 4.7-6.1 4.4-4.2 8.6-8.6 12.9-12.8a10 10 0 0 1 2.9-2c3.3-1.5 6.1-4.1 9.4-5.6 5.1-2.3 9.9-5.5 15.8-5.3 1.2 0 2.3-.8 3.5-1.3.5 1.9-.3 3.7-.3 5.5 0 4.4-.1 8.8-.2 13.2-.2 6.5.1 13 .4 19.5-.3 1.4.2 2.7.3 4l.1 1 .1 2.9a5.29 5.29 0 0 0 .3 3.7 17.59 17.59 0 0 0-.6 4.6 4.34 4.34 0 0 1-3.2 1.1c-2.6 0-5.2-.5-7.8-.5-16.7-.1-33.3-.1-50-.1Z"
        fill="#f8f5cf"
      />
      <path
        d="M327.8 507.5c.1-1.1.2-2.1.3-3.2.4-4.9.4-4.9 5.2-5 16.1 1 32.3.8 48.4.5 4.5-.1 9-.2 13.4-.4 1.1 0 2.2-.1 2.9 1-3.6.4-7.2.8-10.8 1.1-3.9.4-4.7 1.3-4.3 5.2.3 2.8.8 5.7 1.2 8.5-.9 0-1.2.8-1.9 1.2-4.6 2.6-9.3 5-13.5 8.3-4.6 3.6-8.5 7.8-12.7 11.7a58.51 58.51 0 0 0-8.6 11.2c-1.1 1.8-2.8 3.2-3.6 5.3-.7 1.8-1.2 3.9-2.5 5.3-2.1 2.3-3.5 4.7-3.5 7.9-3.3.6-6.5 1.2-9.7-.6v-5.3c.1-1.1.4-2.2.4-3.3.3-9.7.8-19.4.5-29.2-.1-6.7-.8-13.4-1.2-20.2Z"
        fill="#abc0ca"
      />
      <path
        d="M327.8 507.5c.5 6.7 1.1 13.5 1.3 20.2.4 9.7-.2 19.4-.5 29.2a18.59 18.59 0 0 1-.4 3.3c-3.1 1.7-6.6 1-9.9 1.2-12.9.9-25.7 2.2-38.5 3.3l-2 .3c0-4 2.5-7.1 3.9-10.6 3.2-8.1 8.1-15.3 13.2-22.3 3.4-4.7 7.8-8.6 12.1-12.6 3.5-3.2 7.6-5.6 11.6-8.1a30 30 0 0 1 9.2-3.9Z"
        fill="#e59b41"
      />
      <path
        d="M337.9 566.1c0-3.2 1.4-5.6 3.5-7.9 1.3-1.4 1.8-3.5 2.5-5.3.9-2.1 2.5-3.5 3.6-5.3a55.56 55.56 0 0 1 8.6-11.2c4.2-3.9 8.1-8.1 12.7-11.7 4.2-3.3 8.9-5.7 13.5-8.3.6-.4 1-1.2 1.9-1.2a185.66 185.66 0 0 1 3.9 20.8c1.2 8.8 2.3 17.7 2.8 26.6v.1l.2 3c-1.1 1.1-2.4.3-3.6.3-16.5.1-33.1.1-49.6.1Z"
        fill="#abc0ca"
      />
      <path
        d="M516.8 525.9a5.14 5.14 0 0 0-4.6-5.6h-.5c-2.3-.1-4.7.3-7.1-.5-.5-.2-1.1-.1-1.1-.8s.6-.7 1.1-.8c1.7-.1 3.3-.9 5-.5 3 .6 5-.7 6.9-2.8a2.74 2.74 0 0 0 .6-2.1v-6.4c0-.8 0-1.7 1-1.7s1 .8 1 1.5a42.33 42.33 0 0 1 .5 5c-.1 4.8 1.7 6.5 6.4 6.4a20.32 20.32 0 0 1 6 .5c.4.1.9 0 1 .5s-.5.8-.9 1a20.21 20.21 0 0 1-6.5.5c-4 0-6 1.9-6 5.9a17.34 17.34 0 0 1-.7 6c-.1.5-.3 1.1-.9 1.1-.8 0-.9-.7-.9-1.3-.1-1.9.2-4-.3-5.9Z"
        fill="#94aebc"
      />
      <path
        d="M647 566.1h50c2.6 0 5.2.5 7.8.5a4.2 4.2 0 0 0 3.2-1.1c.8 2.5-.3 4.1-2.9 4.1-4 0-8.1-.3-12.1-.4q-19.8-.3-39.6 0c-4.3.1-8.6.4-12.9.4-2.4 0-3.4-1.6-2.7-4.1 3 1.9 6.1 1.1 9.2.6Z"
        fill="#adc2ce"
      />
      <path fill="#abc0ca" d="M390.9 562.8v-.1h.1l-.1.1z" />
      <path
        d="M708.1 553.3c.5.3.5.6.1 1a3.08 3.08 0 0 1-.1-1Z"
        fill="#ebb452"
      />
      <path
        d="M777.3 466.4a20.19 20.19 0 0 0-5.6-3H365.2v.1h-20.1v-.1h-80.6c-3.8 1.6-7.1 3.7-8.7 7.8-.3 1.7.9 3.7-.9 5.1l.6.4h525.4c.2-4-.4-7.6-3.6-10.3Z"
        fill="#cbd9e2"
      />
      <path fill="#c8bed3" d="M885 924.5H189l96-150 508 3 92 147z" />
      <path fill="#abc0ca" d="M596 497.5h32v42h-32z" />
      <path
        fill="#757b97"
        d="m409 775.2-91.5 149.3h12l87.4-149.3H409zM424.9 775.2 344 924.5h10.6l77.3-149.3h-7z"
      />
      <g data-name="Layer 7">
        <path
          d="m708.5 554.5-.1-3.5c.5-.4.5-.8-.1-1.2-.1-1.6-.7-3.2-.4-4.9 5.3-5 10.4-10.3 16.1-15a108.65 108.65 0 0 1 33.4-19.4c10.5-3.9 21.5-5.1 32.6-5-2.1 7.6-4.2 15.1-6.2 22.7-3 11.7-5.2 23.5-7.4 35.4-.2 1.2-.9 2.3-1.1 3.5-.6 3.1-2.4 3.6-5.2 2.8-8.1-2.3-16.2-4.6-24.3-6.7-9.9-2.5-19.9-4.8-29.8-7.1-2.5-.6-5-1.1-7.5-1.6Z"
          fill="#e29e54"
        />
        <path
          d="M790 505.4c-11.1 0-22.1 1.1-32.6 5a111 111 0 0 0-33.4 19.5c-5.6 4.8-10.7 10-16.1 15-.4-7.9-.7-15.7-.5-23.6.2-5.3.2-10.7.2-16 0-2.2 1-4.4.4-6.7a25.4 25.4 0 0 0 .3-5.5 8.31 8.31 0 0 0 0-6.2l-.3-1.8a30.63 30.63 0 0 1 2-9.9c1-2.6 2.8-3.1 5.1-2.5 10.5 2.8 20.9 5.7 31.4 8.4 9.9 2.5 19.8 5 29.9 7q6.45 1.35 12.9 2.4a4.32 4.32 0 0 1 3.6 5v.2a37.33 37.33 0 0 1-2.9 9.7Z"
          fill="#efac4c"
        />
      </g>
      <path d="m398.6 462.1 13.8 4a4.32 4.32 0 0 1 2.9 5.4L405 506.8a4.32 4.32 0 0 1-5.4 2.9l-13.8-4a4.32 4.32 0 0 1-2.9-5.4l10.3-35.3a4.32 4.32 0 0 1 5.4-2.9Z" />
      <path
        d="M681.3 608.6s9 7.2 13.3-2.4-.2-16.1-6.3-16.5-14.8 9.1-12.1 13.3 5.1 5.6 5.1 5.6Z"
        fill="#a32b28"
      />
      <path
        fill="#dba795"
        d="m308.8 662.1 1.3 29.5 16.8-1.1 2.6-31.1-20.7 2.7zM395.8 664.1l-7.3 27.5 16.3 1.4 11.6-26.7-20.6-2.2z"
      />
      <path
        d="m384.9 701.9.5-5.7a23.11 23.11 0 0 1 1.2-5.2l1.3-3.5.2-.5a1.4 1.4 0 0 1 1.8-.8 1 1 0 0 1 .6.5l.7 1a9.59 9.59 0 0 0 13.4.8l-.2-2a5 5 0 0 1 2.2-4.8 1.38 1.38 0 0 1 1.8.2s7.5 7 7.7 7.2l.3.3.3.3.2.2 3 2.5 1.8 1.3.2.2.4.2.1.1.8.5.1.1c.1.1 2 1.2 2.5 1.5l.1.1.6.3.5.3c.5.3 1.6.8 1.6.8l.5.2h.1l.5.2a40.92 40.92 0 0 0 4.9 1.8l6.6 2.1a6.5 6.5 0 0 1 4.5 6.7v.3a8.45 8.45 0 0 1-1.5 3.8l-.1.2a8.72 8.72 0 0 1-7.1 3.7h-.6l-47-4.2c-2.7-.2-4.6-1.9-4.7-4.5 0-.4.1-.9.5-.9l-.2-2.3c-.1-1.3-.1-2.2-.1-3ZM300.9 400.4c-12.3-2.8-32.8-7.5-55.6-4.5-17.9 2.4-48.6 10.7-50.8 26.3-.9 6.1 2.6 15.8 13.8 23.6 15.3 10.7 21.1 81 39.1 89.2 26.2 11.9 97.4-10.8 97.4-10.8 5.2-1.7-7-41-3.3-44.5 5.3-5 8-7.2 8-7.2-2.4 9.8-2.2 41.6 14.9 52 12 7.2 38.5-1.9 39-10.2 0 0-5-12.1-10.8-11.5-2.8.3-6.7-.3-7.7-1.9-5.6-9.1 3.5-45.5-13.1-74.6-.9-1.6-9.9-14.5-25.7-21.9-12.3-5.8-25.1.7-45.2-4Z"
        fill="#333"
      />
      <path
        d="m338.4 381.3-1.5 14.5a4.35 4.35 0 0 0 1.4 3.6 49.2 49.2 0 0 0 7.8 5s-9.2 3.5-22.8 2.1a94.65 94.65 0 0 1-29.2-7.6 121 121 0 0 0 15.8-2.6c1.9-.5 2.8-2.9 2.9-4l.5-4.7.3-2.7.7-6.9Z"
        fill="#dba795"
      />
      <path
        d="m310.1 350.9.5.1 1-9.4c1.4-13.4 12.9-23.3 25.8-22 12.9 1.3 22.2 13.2 20.9 26.7l-1.8 16.3a35 35 0 0 1-6.6 17.3c-4.7 6.1-9.9 8.6-18.7 7.6-11-1.2-20.2-7-21.4-26-3.4-.9-5.1-2.9-5.2-5.8-.2-4 2.8-5.1 5.5-4.8Z"
        fill="#dba795"
      />
      <path
        d="M349 358.9a1.16 1.16 0 0 0 1.1 1.3h.1a1.4 1.4 0 0 0 1.2-1.4 1.23 1.23 0 0 0-1.1-1.3 1.41 1.41 0 0 0-1.3 1.4ZM333.8 357.3a1.24 1.24 0 0 0 1.2 1.3 1.4 1.4 0 0 0 1.2-1.4 1.3 1.3 0 0 0-1.2-1.3 1.48 1.48 0 0 0-1.2 1.4Z"
        fill="#2e2122"
      />
      <path
        d="M343.8 360.7c.1 1.1.3 2.1.5 3.2a9.08 9.08 0 0 1 .3 2.3 1.38 1.38 0 0 1-.5 1.3 2.26 2.26 0 0 1-1.6.2 3.09 3.09 0 0 1-2-1.7.27.27 0 0 1 .5-.2 2.58 2.58 0 0 0 2 1.5c.5 0 1-.1 1-.6a5.83 5.83 0 0 0-.2-2.3c-.2-1.2-.4-2.3-.6-3.5.1-.4.5-.5.6-.2ZM307.7 355.4a1.79 1.79 0 0 1 1.4-.4 3.27 3.27 0 0 0-1.1-1.5.45.45 0 0 1 0-.5c.1-.1.2-.1.4-.1a5.18 5.18 0 0 1 1.4 2.1 5 5 0 0 1-.1 2.7c-.1.4-.7.2-.6-.2a4.08 4.08 0 0 0 .1-1.9h-.8l-.1.1h-.1l-.1.1v.1l-.1.1V356.8c0 .1 0 .1.1.1v.1a.28.28 0 0 1-.4.4 2 2 0 0 1-.4-.8 1.26 1.26 0 0 1 .4-1.2Z"
        fill="#9e695c"
        opacity={0.2}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M342.2 374.2a7.15 7.15 0 0 0 5.2-1.9c.1-.1.1-.2-.1-.2 0 0-3 .2-4.9.1a39.67 39.67 0 0 1-4.8-.7c-.2 0-.2.1-.1.2a5.62 5.62 0 0 0 4.7 2.5Z"
        fill="#fff"
      />
      <path
        d="M260.8 538.2c-3.1 36 27 36.6 27 36.6 2 52.8 17.7 87 17.7 87 6 3 24.6.8 24.6.8 12.5-65.5 7.4-90.4 7.4-90.4 10.5 3.8 52.5 15.5 55.4 25.4 7.6 26 2.9 66.6 2.9 66.6 5.2 5.2 19.8 5.4 19.8 5.4 16.1-23 27.7-82.9 22.2-97.9-9.7-26.9-74.9-47.5-91.7-49.6l-21.6 3c-9.6-9-23.1-8.4-30.4 5.8Z"
        fill="#e6e6e6"
      />
      <path
        d="M331 709c-2.6 7-25.6 4.8-27.3-2.3-.7-3.1.3-5.9 1.9-8.6 2-3.4 2.4-6.9 3.3-10.2 1.1-4 5.9-7 10.4-6.5 4.1.5 8 4.6 8.3 9.1.2 3.5.4 4.5 2.1 9.1 1.1 3.3 2.7 5.7 1.3 9.4Z"
        fill="#333"
      />
      <g clipPath="url(#a)">
        <path
          d="M331 709c-2.6 7-25.6 4.8-27.3-2.3-.7-3.1.3-5.9 1.9-8.6 2-3.4 2.4-6.9 3.3-10.2 1.1-4 5.9-7 10.4-6.5 4.1.5 8 4.6 8.3 9.1.2 3.5.4 4.5 2.1 9.1 1.1 3.3 2.7 5.7 1.3 9.4Z"
          fill="#333"
        />
      </g>
      <path
        d="M352.6 470a52.24 52.24 0 0 0 9.5-13.8c.2-.3-.3-.6-.5-.3a53.4 53.4 0 0 1-9.5 13.7.32.32 0 0 0 .5.4Z"
        fill="#757575"
        opacity={0.5}
      />
      <path
        d="M293.8 531.2c-3.2 10.7-4.2 21.9-5.3 33-.3 3.3-.6 6.7-.9 10 0 .4.5.4.6 0 1-11.5 1.9-23 4.1-34.4.6-2.8 1.2-5.7 2.1-8.5a.27.27 0 0 0-.3-.3 1.24 1.24 0 0 0-.3.2ZM324.5 525.8c1.8 1.8 2.8 4.4 3.6 6.7a95.93 95.93 0 0 1 3.2 10.4c1.9 7.2 3.4 14.6 4.6 22 .4 2.3.8 4.6 1.1 7 0 .4.6.2.5-.2-.8-5.4-1.8-10.8-2.9-16.2a159.39 159.39 0 0 0-5.8-22.6c-1-2.6-2-5.6-4-7.6 0-.2-.4.2-.3.5ZM391.2 594.2a17.77 17.77 0 0 1 1.4-5 20.57 20.57 0 0 1 2.1-4.8 21 21 0 0 1 7-6.6c.3-.2 0-.7-.3-.5a22.27 22.27 0 0 0-7.2 6.8 34.78 34.78 0 0 0-2.1 4.8 16.84 16.84 0 0 0-1.5 5.3.3.3 0 1 0 .6 0ZM392.5 596a13.84 13.84 0 0 1 3.9-1.8 30.11 30.11 0 0 1 12.3-1.3c.4 0 .4-.5 0-.6a32.52 32.52 0 0 0-8.8.4 30.3 30.3 0 0 0-4.3 1.2 10.85 10.85 0 0 0-3.4 1.7c-.4.2 0 .6.3.4Z"
        fill="#acadad"
      />
      <path
        d="M384.3 500.8c-3.9 2-6.2 5.8-7.6 9.8-.1.4.4.5.5.1 1.4-3.9 3.6-7.5 7.4-9.5.3-.1 0-.6-.3-.4Z"
        fill="#757575"
        opacity={0.5}
      />
      <path
        d="M305.7 479.8a.56.56 0 0 0-.5.6.47.47 0 0 0 .5.5"
        fill="#844746"
        opacity={0.35}
      />
      <path
        d="M394 512c8.1 7.7 16.4-1.5 21-11.6 2.3-5 3.1-11.6-1-16.7-2.1-2.6-5.3-4.5-6.2-3.4-1.6 1.8 4.8 8.9 3.1 10.6-.5.5-8.4-14.7-11.8-12.7-2.8 1.6 6 11.6 4.9 12.3s-7.7-10.7-10.1-8.9c-2.7 2 6 11.4 4.5 12.6s-8.1-7.9-10.2-6.2c-1.8 1.5 2.5 3.5 3.8 9.2.2.8.6 1.1.8 7.1.2 4.1 0 6.7 1.2 7.7Z"
        fill="#dba795"
      />
      <path
        d="M224 417.9a121.17 121.17 0 0 1 12.9 5.4 53.27 53.27 0 0 1 11.5 7.3c.3.2.7-.2.4-.4a59.28 59.28 0 0 0-11.7-7.4 123.46 123.46 0 0 0-13-5.5.32.32 0 0 0-.1.6ZM249.7 430.5a13.35 13.35 0 0 1 .1-10.2c.1-.3-.4-.6-.5-.3a13.91 13.91 0 0 0-.2 10.6c.2.4.7.3.6-.1Z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M256.3 440c7.4 3.3 15.4 4.5 18 5.6 8.1 3.5 9.7 5.7 16.3 10.5 19.7 14.4 15 22.5 9.7 21.2-2.4-.6-20.1-10.8-21.1-9.7s12.4 13.1 10.6 14.5c-2.2 1.8-7.5-5.4-20-13.4-12.2-7.8-15.7-10.4-18.5-14.6Z"
        fill="#dba795"
      />
      <path
        d="M208.2 445.8c12.5 6.5 49.1 14 49.1 14 4.9-3.8 5.9-17.4 5.9-17.4-18-16.5-20.7-14-23-14.5-3.5-.8-15.2-3.4-24.5 4.1-1.6 1.5-7.5 13.8-7.5 13.8Z"
        fill="#2e2122"
      />
      <path
        d="M175.1 510.5c-7.3-7.5-10.9-17.5-12.8-27.7-.1-.6-1.1-.4-1 .3 1.9 10.3 5.7 20.5 13.1 28.1.4.5 1.1-.2.7-.7ZM181 510.7c2.4-5 4.3-11 3.5-16.6-.1-.6-1.1-.4-1 .3.8 5.3-1.1 11.1-3.4 15.8-.3.6.6 1.1.9.5Z"
        fill="#281a24"
        opacity={0.15}
      />
      <path
        d="M356.6 325.3c-1.7-4-17.3-11.9-41.8-2.6 0 0-3.7-2.1-7.3 6.8-2.5 6.2-1.7 19.7 2.8 24.1l2.7-.1c2.9-1.8-1-13.9 3-17 33.3-1.9 38.7-2.1 38.7-2.1 1.8 3.4 2.5 16.8 2.5 16.8a5.44 5.44 0 0 1 1.8 0c2.2-3.3 1.9-15.7-2.4-25.9Z"
        fill="#061a47"
      />
      <path
        d="M312.1 336.7c-4.6-2-8.6-8-7.3-13.1 1-3.7 3.5-6.5 8.3-9.1 2-1 7.6-2.5 14-2.8 5.8-.3 5.9 1.5 12.2 1.8 9.7.4 11.2-1.7 14.6 1 2.8 2.2 3 3.3 6.3 7.5 3.8 4.9 8.7 3.3 10.6 7.3 1 2.2-.4 2.8-1.5 11.1-.9 6.3 1.2 10.1-.4 11.4-3.2 2.6-6.4-2.3-9.9-2.3a18.81 18.81 0 0 1-8.7-2.1c-3-3.1.1-8.1-2.3-10-2.7-2-6.9 3.9-14.6 3.5-4.8-.3-5-2.6-11.9-3.6-5.6-.8-6.5.7-9.4-.6Z"
        fill="#02594f"
      />
      <path
        d="M336 330.3c2.2.4 4.1-.6 6.2-1.2a12.82 12.82 0 0 1 7-.2c2 .5 4.1 1.1 5.5 2.6s1.8 3.7 3.4 5.2a17.82 17.82 0 0 0 5.7 3.2c.6.2.9-.7.3-1a16.19 16.19 0 0 1-5.3-2.9c-1.5-1.5-2-3.6-3.4-5.2a9.68 9.68 0 0 0-5-2.6 15.61 15.61 0 0 0-6.8-.5c-2.4.5-4.8 2.1-7.3 1.7-.7-.2-.9.8-.3.9ZM351.8 324.1c2.6-.7 4.6 1.5 6.2 3.2s3.5 3.2 5.9 3c.6-.1.6-1.1 0-1-2.7.2-4.5-2.1-6.1-3.8s-3.8-3.1-6.2-2.4a.62.62 0 0 0-.4.6.49.49 0 0 0 .6.4Z"
        fill="#097263"
      />
      <path
        d="M346.6 350.7c-.6-.6-.3-1.1 1-1.6a10.45 10.45 0 0 1 4.3-.6c3 .1 5 1.8 4.1 1.6a15.61 15.61 0 0 0-5.7-.1c-1.6.2-3.3 1.1-3.7.7ZM338.7 350.4c.6-.7.3-1.2-1.1-1.9a11.66 11.66 0 0 0-4.5-.9c-2.5 0-4.6 1.9-3.9 1.7a13.19 13.19 0 0 1 5.6.1c1.7.3 3.4 1.5 3.9 1Z"
        fill="#052620"
      />
      <g fill="#e8a18e">
        <path d="M448.8 567.8c6.9-3.3 15.3-4.7 16.4-3.8-8.6 5.8-.5 20-16.1 29a6.81 6.81 0 0 1-2.4.8 11 11 0 0 1-10.6-6.8l-1.3-3.4a11.92 11.92 0 0 1 3.7-13 6.5 6.5 0 0 1 2.2-1.1c2.3-.5 5.5-.5 8.1-1.7Z" />
        <path d="M539.6 534.7c-20 8-39.5 16.6-52.9 22.1-5.6 2.3-15.1 6.3-21.1 7.1-4 .5-11.5 3.1-15.4 4.8a18.29 18.29 0 0 1-2.5.8c-4.1 1-5.4 4.5-4 8.5l3.5 8.8a4.46 4.46 0 0 0 5.4 3 4.15 4.15 0 0 0 2-1.2c4.3-4.2 8.5-9.1 12.3-10.5 17-6.5 52.5-4.4 82.9-17.3 10-4.3 1.4-30.7-10.2-26.1Z" />
      </g>
      <path
        d="M469.9 563c0 5.9 4.2 13 4.2 13a2.88 2.88 0 0 0 1.3-.1 8.8 8.8 0 0 0 1.5-.5c-4.7-8.7-4.5-13.2-4.5-13.2Z"
        fill="#382632"
      />
      <path
        d="M475.5 541h74.6s-3.9-13.3-2-33h-70.5c2.3 21.6-2.1 33-2.1 33Z"
        fill="#061a47"
      />
      <path
        d="M448.1 468c9.1-14.3 8.2-34.6 18.4-44.3 7.4-7.1 16.5-8.2 28.4-10.5h40.2c11.5 2.1 17.6 3.2 23.7 7.7 10.8 7.9 12.2 27 15.7 43.6a25.62 25.62 0 0 0 3 7.5c-11.2 6.4-27.6 4.4-27.6 4.4 5.2 21.1 1.2 43.2-2.8 45.4-1.3.7-2.4 1.5-12.8 1.5-3.7 0-8.1-1.5-14.5-1.5 0 3.9-3.5 7-7.9 7s-7.9-3.1-7.9-7c-5.7 0-12.3 2-15.8 2.1-10.6.3-10.4-1.1-10.4-1.1-12.4-10.7-2.6-48.1-2.6-48.1a147.07 147.07 0 0 1-27.1-6.7Z"
        fill="#061a47"
      />
      <path
        d="M494.9 413.1s6.1-.6 7.8-2a5.07 5.07 0 0 0 2.2-3.9v-11.1l19.1-.2v11.2a4.7 4.7 0 0 0 2.3 4c3.6 2 8.8 2 8.8 2-3.7 2.7-10.5 9.8-21.7 9.3-12.7-.5-18.5-9.3-18.5-9.3Z"
        fill="#e8a18e"
      />
      <path
        d="M504.9 400.6c6.5 3.7 13.3 3.7 19.1-.1v-4.8h-19.1Z"
        fill="#9e6352"
        opacity={0.3}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M473.3 467.2c-7.3-.8-14.3-2.9-21.3-5.2-.5-.1-.3-.9.2-.8 6.9 2.2 13.9 4.3 21.2 5.1a.45.45 0 0 1-.1.9ZM573.3 465.3c-7.3 3.6-15.5 4-23.5 4a.35.35 0 0 1-.3-.5.32.32 0 0 1 .3-.3c7.9 0 16-.3 23.1-3.9.4-.2.8.5.4.7ZM539.5 515.1a36.42 36.42 0 0 0 10.4-12.9c.2-.5.9 0 .7.4a38 38 0 0 1-10.5 13c-.4.4-1-.2-.6-.5ZM529.8 512a42.64 42.64 0 0 0 2.4-25.2c-.1-.5.7-.7.8-.2a43.16 43.16 0 0 1-2.4 25.6c-.2.5-1 .3-.8-.2Z"
        fill="#281a24"
        opacity={0.1}
      />
      <path
        d="M496.2 444.9A32.21 32.21 0 0 0 493 455c-.1.5-.9.5-.8 0a32.17 32.17 0 0 1 3.3-10.5c.2-.4.9 0 .7.4Z"
        fill="#281a24"
        opacity={0.15}
      />
      <path
        d="M588.6 522.7c-6.4-11.1-22.5-10.3-31.3-7.6-3.2 1-7.4 2.5-14.6 7a73.23 73.23 0 0 1-9.5 5.2c-4.5 2-13.1 1.4-20 .6-12.3-1.4-9 .1-28.8-3.3-29-5-34.8-7.8-50.4-7.6-7.1.1-17 .8-20.2 6.1-6.9 11.5 2.9 24.2 14.9 31.8s36.7 15.1 45.1 26.8a122.89 122.89 0 0 1 11-11.8 45.76 45.76 0 0 0 12.3-17.2 21.93 21.93 0 0 0 2.3 4.9l14.4 19.2c9.3-5.8 28.7-10.9 46-17.2 15.7-5.7 38.2-20.7 28.8-36.9Z"
        fill="url(#b)"
      />
      <g fill="#e8a18e">
        <path d="M539.8 579.6c-5.8-4.9-13.6-8.4-14.9-7.8 6.9 7.8-4.5 19.5 8.2 32.1a6 6 0 0 0 2.1 1.4 11.09 11.09 0 0 0 12-3.9l2.1-3a11.92 11.92 0 0 0-.3-13.4 4.94 4.94 0 0 0-1.9-1.6c-2.1-1.1-5.2-2-7.3-3.8Z" />
        <path d="M497.2 552.7c3 2.3 6.1 4.7 8.7 6.6 4.8 3.6 13 10 18.6 12.3 3.7 1.5 10.3 5.9 13.7 8.6a16.44 16.44 0 0 0 2.2 1.4c3.7 2 4.1 5.7 1.7 9.2l-5.6 7.6a4.27 4.27 0 0 1-5.9 1.5 4.36 4.36 0 0 1-1.6-1.7c-3.1-5.1-5.9-10.9-9.2-13.3-7.5-5.3-20.3-9.9-34.3-15.5 0 0 3.3-3.3 5.8-6.3a55.86 55.86 0 0 0 5.9-10.4Z" />
      </g>
      <path
        d="M496.9 552.5c-7.4-5-14.9-10-22.5-14.7s-15.4-9.6-23.8-12.5a36.22 36.22 0 0 0-15.3-2.1c-.5 0-.5-.7 0-.8 8.9-.9 17.4 2.4 25.1 6.5 8.2 4.3 16.1 9.3 23.9 14.3 4.4 2.8 8.7 5.7 13 8.6.4.3 0 1.1-.4.7ZM562.8 519.4c-2.8-.7-5.6-.2-8.4.2a78.42 78.42 0 0 0-8.1 1.8c-.2.1-.4-.1-.5-.3s.1-.4.3-.5a67.71 67.71 0 0 1 8.7-1.9 22.61 22.61 0 0 1 8.2-.1.41.41 0 0 1-.2.8ZM532.4 528.5c-3.1 1.8-6.2 3.7-9.2 5.6s-5.6 4-8.3 6.1c-5.5 4.3-12.2 6.9-18.6 9.5-.5.2-.7-.6-.2-.8 6.6-2.8 13.4-5.5 19.1-10a137.44 137.44 0 0 1 16.9-11.2.37.37 0 0 1 .5.2c0 .3 0 .5-.2.6Z"
        fill="#75d1c6"
        opacity={0.8}
      />
      <path
        d="M487.5 547.6a76 76 0 0 1-21.8 23.7c-.4.3-.8-.4-.4-.7a74 74 0 0 0 21.5-23.4c.1-.2.4-.3.5-.1.2 0 .3.3.2.5ZM508.7 552.5a88.42 88.42 0 0 0 26.8-12.4c.4-.3.8.4.4.7a89.5 89.5 0 0 1-27 12.4c-.2.1-.4-.1-.5-.3s0-.4.3-.4Z"
        fill="#75d1c6"
        opacity={0.8}
      />
      <path
        d="M493.4 572.8a43.71 43.71 0 0 1-7.8-3.1c-.3-.2 0-.7.3-.5a54.51 54.51 0 0 0 7.6 3c.1 0 .2.2.2.3a.27.27 0 0 1-.3.3Z"
        fill="#9e6352"
        opacity={0.3}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M513.4 422.3a6.47 6.47 0 0 0-1.3-.4h-.7a.76.76 0 0 0-.5.2 1.18 1.18 0 0 0-.1 1 1.46 1.46 0 0 0 .6.9.3.3 0 0 1 0 .4.3.3 0 0 1-.4 0 2 2 0 0 1-.8-1.2 1.63 1.63 0 0 1 .2-1.5 1.65 1.65 0 0 1 1.5-.5 5.49 5.49 0 0 1 1.7.5c.1 0 .2.2.2.4s-.2.3-.4.2Z"
        fill="#f78c77"
      />
      <path
        d="M511 424.5a1.79 1.79 0 0 0-.7.5.75.75 0 0 0-.1.8c.1.3.3.5.4.8a1.7 1.7 0 0 0 .6.6c.1.1.2.2.1.4s-.2.2-.4.1a2.7 2.7 0 0 1-.8-.7 3.13 3.13 0 0 1-.5-1 1.09 1.09 0 0 1 .2-1.1 2.36 2.36 0 0 1 .9-.8c.1-.1.3 0 .4.1s.1.2-.1.3Z"
        fill="#f78c77"
      />
      <path
        d="M488 421.9a8.34 8.34 0 0 0 6.4 4.6 16.67 16.67 0 0 0 5.9.1l1.2 11.3 27.5-.3 3.7-30.6h-34.4l.2 2a10.55 10.55 0 0 0-5 .3 9.82 9.82 0 0 0-5.5 5.1 8.58 8.58 0 0 0 0 7.5Zm2.7-4.4v-.4a1.85 1.85 0 0 1 .2-.7 2.57 2.57 0 0 0 .2-.5 2.19 2.19 0 0 1 .3-.5c.1-.1.3-.5.5-.7l.1-.1.2-.2.9-.9.2-.1.3-.2.6-.3.2-.1.2-.1c.2-.1.5-.1.7-.2a6.47 6.47 0 0 1 2.4-.1c.3.1.6.1.9.2l.3.1 1 10.3a11.42 11.42 0 0 1-5.2-.1 2.92 2.92 0 0 0-.9-.2c-.3 0-.4-.2-.5-.2a2.51 2.51 0 0 1-.7-.4l-.2-.1-.1-.1-.5-.5c-.2-.3-.1-.1 0 0l-.2-.3-.3-.6-.1-.2v-.1a2.35 2.35 0 0 1-.2-.8 4.33 4.33 0 0 0-.1-.5 2.49 2.49 0 0 1-.2-1.4Z"
        fill="#fcfbf0"
      />
      <path
        d="M500.1 427.2c.1.9.2 1.8.3 2.8v.4c0 .1-.3.2-.3 0-.1-.9-.2-1.8-.3-2.8v-.4c-.1-.2.3-.2.3 0Z"
        fill="#d8d8d8"
      />
      <path
        d="M454.8 470.1s5.6 1.6 9.3 2.4c3.9.9 11.1 2.1 11.1 2.1a54.13 54.13 0 0 0 .2 9c3.8-5.6 16.5-24.4 18.5-36.6.6-3.8-3.9-8.1-3.9-15.7 0-2.5-.4-5 1-7.5 4.1-7.9 16.2-12.2 17.3-11.2s-.8 2.1-.8 2.1c.8-.3 2.5-.9 3-.3.9 1.2-1.3 2.8-3 4.6-2 2.1-3.5 3.8-3.3 4.1.3.5 9.2-3.8 10-2.7s-.4 2.4-.4 2.4c.8.1 1.5.5 1.2 1.5s-3.2 3.1-6.9 5.7a8.17 8.17 0 0 0-3.3 5.5c-.5 3 1.4 4.2 1.3 7.5 0 3-1.8 5.1-2.2 6.1-2.7 7.1-15.4 59.6-28.7 62.2-11.6 2.3-19.2-17.5-20.4-41.2Z"
        fill="#e8a18e"
      />
      <g clipPath="url(#c)">
        <path
          d="M570.3 474.8a64.59 64.59 0 0 1-9.8 1.6c-4 .2-10.6-.1-10.6-.1a58.31 58.31 0 0 0-2.2 7.1c-3.8-5.6-14.9-22.8-16.8-35-.6-3.8 3.9-8.1 3.9-15.7 0-2.5.4-5-1-7.5-4.1-7.9-16.2-12.2-17.3-11.1-.9.9.8 2.1.8 2.1-.8-.3-2.5-.9-3-.3-.9 1.2 1.3 2.8 3 4.6 2 2.1 3.5 3.9 3.3 4.1-.3.5-9.2-3.8-10-2.7s.4 2.4.4 2.4c-.8.1-1.5.5-1.2 1.5s3.2 3 6.9 5.7a8.17 8.17 0 0 1 3.3 5.5c.5 3-1.3 4.2-1.3 7.5 0 3 1.8 5.1 2.2 6.1 2.7 7.1 11.2 62.2 24.5 64.8 11.6 2.2 23.6-16.9 24.9-40.6Z"
          fill="#e8a18e"
        />
        <path
          d="M548.3 483.4a21.33 21.33 0 0 1 6.6 15.4c0 .2-.2.3-.3.2a.22.22 0 0 1-.2-.2 20.73 20.73 0 0 0-6.5-15 .28.28 0 1 1 .4-.4ZM528.1 424.2a25.48 25.48 0 0 0-5.1-4.1l-2.8-2a20.07 20.07 0 0 0-2.7-1.7c-.3-.2 0-.6.3-.5a17.77 17.77 0 0 1 2.7 1.7l3 2.1a27.44 27.44 0 0 1 5 4 .32.32 0 0 1-.4.5ZM525.8 427.4c-1.6-.9-3.3-1.7-5-2.5-.3-.1 0-.6.3-.5 1.7.8 3.3 1.6 5 2.5.4.1 0 .6-.3.5ZM522.3 431.8c-3-3.2-7-5.3-11-7.2-.3-.2 0-.6.3-.5 4 1.9 8 4 11.1 7.3.3.2-.2.6-.4.4Z"
          fill="#9e6352"
          opacity={0.3}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <path
        d="M474.9 484.2a17 17 0 0 0-6.5 12.3.3.3 0 0 1-.6 0 17.54 17.54 0 0 1 6.6-12.7c.4-.2.8.2.5.4ZM510.6 424.4a18.58 18.58 0 0 0-5.3 3c-.3.2-.7-.1-.4-.4a18.1 18.1 0 0 1 5.4-3.1c.3-.2.6.3.3.5ZM506.9 415.2a23.31 23.31 0 0 0-6.5 6.4c-.2.3-.7 0-.5-.3a24.74 24.74 0 0 1 6.7-6.6c.3-.2.6.3.3.5Z"
        fill="#9e6352"
        opacity={0.3}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M804.7 813.2c-5.7-2.8-20.5-.5-39.6-2.8-2.3-.3-10.4-21.6-26.1-72.8-6.8-22.1-11.6-38.5-15.7-51-1 .6-1.9 1.1-2.8 1.7a58.06 58.06 0 0 0-7.6 5.4 25.14 25.14 0 0 0-5.9 7.1 19 19 0 0 0-2.2 9.3c1.8 4.4 5.7 15 12.9 34 18.1 47.6 34.4 75.4 39.9 79.2 3.9 2.7 30.6 1.5 31.3-.1s-1.6-2.5-1.6-2.5c12.7-.6 24.5-4.1 17.4-7.5Z"
        fill="#995d4d"
      />
      <path
        d="M764.7 829.9c-1.9-2.7-5-3.8-8-4.3a75 75 0 0 0-11.6-.4c-4.1.1-8.2.4-12.3.8-8.2.8-16.4 2.1-24.6 3.1a213.49 213.49 0 0 1-25.2 1.8c-16.7.2-33.3-1.8-49.9-3a37.48 37.48 0 0 1-11-2 .19.19 0 0 0-.3.1 204.79 204.79 0 0 1-35.2 29.1c-5.6 3.6-11.5 6.8-16.7 10.9a33.37 33.37 0 0 0-6.4 6.6c-1.7 2.4-3.6 5.7-3.2 8.8.9 5.9 8.7 6.1 13.2 6.2q12.6.45 25.2.3c16.8-.1 31.8.6 48.6 1 17.6.3 70.9 9.4 87.6-1 17.9-11.1 26.2-42 29.5-49.3 1.4-2.9 2.3-5.9.3-8.7Z"
        fill="#cbd9e2"
      />
      <path
        d="M606.2 812.6c1.4-2.5 5.5-14.9 7-17.8a52.83 52.83 0 0 0 5.9-17.7c-13.3-5.8-22-7.8-30.8-5.9-26 5.7-81.4 64.1-122.1 64.1-18.1 0-31.5-2-32.7 1.9-1.1 3.6-.2 6.2 6.2 9.7 7.3 4 14.5 1.5 24.5 5 5.7 2 10 8.8 17 8.4 1.3-.1 5.5.4 8.4-3.6 1.3-1.8 2.3-6 3.9-8.8s4.7-6.8 12.3-8.7c19.9-4.4 38.7-8.3 56.5-17 20.9-10.2 27-14.7 34-16 .4-.2 7 4 9.9 6.4Z"
        fill="#a06352"
      />
      <path
        d="M822.3 870.4c-5.1-3.8-20.1-4.3-38.4-10.1-2.2-.7-6.2-23.1-12.2-76.4-7.6-67.3-7.6-84.1-20.7-94.5a59.06 59.06 0 0 0-20.9-10.6 14.16 14.16 0 0 1-10.2-13.7v-13.4h-22.8l.6 22.3a7.84 7.84 0 0 1-5.8 7.8c-6.4 1.8-9.2 3-10.9 5.7-4.7 7.5 1 21.8 3.6 33.3a64 64 0 0 0-2.1 13.8 42.3 42.3 0 0 0 1.6 13.2c5.8-.2 11.5-1.4 17.3-1.8 5.5-.4 11-.5 16.6-.5 9 0 17 .6 24.1 6.7.1-1.5.1-3 .1-4.6.1.7 2.5 10.8 7.5 38.5 9 50.1 19.8 80.5 24.5 85.2 3.3 3.4 29.8 7.1 30.8 5.7s-1.1-2.8-1.1-2.8c12.5 2.1 24.7.8 18.4-3.8Z"
        fill="#ad6b55"
      />
      <path
        d="m697.5 667.5.1 4.7c16.3 1 22.2-13.2 22.2-13.2-4.2.8-22.3 8.5-22.3 8.5Z"
        fill="#9e695c"
        opacity={0.2}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M708.7 593.2c-25.4-3.7-37 12.4-31.4 34.2 4.3 16.6 13.7 30.1 30.9 30.1 7.8 0 17-5.3 17-5.3 5.8 5.7 20.3-14.4 13.8-34.7-4.2-13-13-21.8-30.3-24.3Z"
        fill="#a02410"
      />
      <path
        d="M720.3 643.2a9.13 9.13 0 0 0-1.3-.8c-1.1-.4.5-2.2.5-3.5 0-15.8-9.7-29.2-21.7-28.6-14.2.8-20 5.5-20.6 19.4-.3 5.9-2.9 8.4-5.5 11.4a1.9 1.9 0 0 0 .4 2.6 2 2 0 0 0 1.5.3l2.1-.2a.82.82 0 0 1 .9.8c1.9 13.1 7.4 22.9 21.3 22.9 17.6 0 24.8-11.2 27.5-15.3-.2 0-4.9-5.4-5.1-9Z"
        fill="#ad6b55"
      />
      <path
        d="M682.8 638a1.58 1.58 0 0 1-2.2.2c-.1 0-.1-.1-.2-.2a1.87 1.87 0 0 1 0-2.6 1.58 1.58 0 0 1 2.2-.2l.2.2a1.87 1.87 0 0 1 0 2.6Z"
        fill="#2e2122"
      />
      <path
        d="M682.8 614.4c3.7 6.8 21 8.5 36.5 28.2 1.6 2 4.6-1.9 6.5-4.4 4.5-5.7-1.9-23.4-15-29.7-11.6-5.6-30.7.9-28 5.9Z"
        fill="#a02410"
      />
      <ellipse cx={717.9} cy={637.3} rx={5.8} ry={6.5} fill="#9e695c" />
      <path
        d="M691.1 631.3a35.06 35.06 0 0 0-10.7-1c-.7 0-1.1-1.5-.2-1.8 3-.9 7.9.5 9.6 1.2s3.1 2 1.3 1.6Z"
        fill="#a32b28"
      />
      <path
        d="M719.8 634.5c0-.2-.2-.3-.4-.2a4.53 4.53 0 0 0-2.1 1.5 6.18 6.18 0 0 0-.9 2.7c0 .4.6.4.7 0a5.92 5.92 0 0 1 .5-1.9h.1l.2.1h.2l.2.1.1.1.1.1v1l-.1.1-.1.1-.1.1h-.1a.44.44 0 0 0-.1.5c.1.2.3.2.5.1a1.34 1.34 0 0 0 .6-.7 1.81 1.81 0 0 0 .1-1.6 2.28 2.28 0 0 0-1.2-.6 3.55 3.55 0 0 1 1.6-1.1.76.76 0 0 0 .2-.4Z"
        fill="#9e695c"
        opacity={0.5}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M606.3 819.2c1.3-2.6 4.9-15.1 6.3-18a51 51 0 0 0 5.1-18c-13.5-5.3-22.3-6.9-31-4.6-25.8 6.8-78.7 67.4-119.4 69-18 .7-31.6-.7-32.6 3.2-.9 3.7 0 6.2 6.6 9.5 7.4 3.7 14.6.9 24.7 4 5.8 1.8 10.3 8.4 17.3 7.7 1.3-.1 5.5.2 8.2-4 1.2-1.8 2.1-6.1 3.6-9s4.4-7 11.9-9.2c19.7-5.2 38.3-9.8 55.8-19.3 20.5-11.1 26.4-22.8 33.3-24.4.5-.2 7.2 10.8 10.2 13.1Z"
        fill="#ad6b55"
      />
      <path
        d="M740.7 824.1c-1-6.8-.8-20.4-.5-31.7.2-10.7.7-21.1 1.2-29.2l.8-14.8s-9.6-3.2-16.4-10.6c-3.9-4.2-9.6-8.7-23-6.9A33.75 33.75 0 0 0 690 735s-2.5-7.6-6.5-8.7c-3-.8-11.5 11.4-8.5 20.2 1.8 5.4 3.6 6.6 8 9.3 2.6 19.1-7 40.8-7 40.8l-.6 2.1c-.1 0-44.2-17.6-57.5-22.9-1.3 3.8-2.7 7.6-4.3 11.3-1.5 3.5-3.1 7-4.8 10.4s-4.3 6.5-5.4 10.2c-7.7 25.6-25.8 42.1-27.2 44.7 17.8 13.6 52.3-1.8 128.1 13.7 24.4 5 36.8-13.6 38.2-25.1a46 46 0 0 0-1.8-16.9Z"
        fill="#26211d"
      />
      <g opacity={0.8}>
        <path
          d="M741.6 747.4a142.94 142.94 0 0 1-4.4-17.1c-.1-.4.5-.6.6-.2a149.6 149.6 0 0 0 4.4 17.2c.2.3-.5.5-.6.1Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <g opacity={0.8}>
        <path
          d="m719.5 682.3-11.7 3.6c-.4.1-.6-.5-.2-.6l11.7-3.6c.4-.1.6.5.2.6Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <g opacity={0.8}>
        <path
          d="M700.2 685.7a14 14 0 0 1-4.3-2 .44.44 0 0 1-.1-.5c.1-.2.3-.2.5-.1a12 12 0 0 0 4.1 2 .4.4 0 0 1 .2.4c-.1.2-.3.3-.4.2Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <g opacity={0.8}>
        <path
          d="M738.2 694.2c-1.6 1.9-3.4 4-3.8 6.6s1 5.1 1.3 7.7c0 .4-.6.4-.7 0-.3-2.8-1.8-5.2-1.2-8.1.5-2.6 2.3-4.7 4-6.7.2-.2.7.2.4.5Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <g opacity={0.8}>
        <path
          d="M596.2 805.6c.6-1.6 1.3-3.2 1.9-4.8a10.69 10.69 0 0 0 .7-5c0-.3.5-.5.5-.2.5 3.5-1.3 7-2.6 10.2-.1.3-.7.2-.5-.2Z"
          fill="#9e695c"
          opacity={0.5}
          style={{
            isolation: "isolate",
          }}
        />
      </g>
      <path fill="#757b97" d="M718 929.2h89.2v10.4H718z" />
      <path fill="#a35655" d="M725 914.4h79v14.7h-79z" />
      <path fill="#93a17a" d="M721.1 901.5h79.4v12.9h-79.4z" />
      <path fill="#f8d1bf" d="M789.2 914.4h2v14.7h-2zM782.6 914.4h2v14.7h-2z" />
      <path fill="#636b89" d="M786.9 931.2h6.5v6.9h-6.5z" />
      <path fill="#809065" d="M744.8 905.5h32.1v6.5h-32.1z" />
      <path
        d="M788.5 880.5a9.82 9.82 0 0 0-5.5-5.1 8.85 8.85 0 0 0-5.1-.3l.2-2h-34.7l2.8 25.2h29.4l.5-5.3a16.67 16.67 0 0 0 5.9-.1 8.34 8.34 0 0 0 6.4-4.6 9.25 9.25 0 0 0 .1-7.8Zm-2.7 4.5a4.33 4.33 0 0 0-.1.5c-.1.3-.1.6-.2.8v.2a.35.35 0 0 1-.1.2l-.3.6-.2.3c0-.1.2-.2 0 0l-.5.5a.35.35 0 0 1-.2.1l-.2.1c-.2.1-.5.3-.7.4a1.69 1.69 0 0 1-.5.2l-.9.3a13 13 0 0 1-5.2.1l1-10.4.3-.1a6.51 6.51 0 0 1 3.4-.2c.2.1.5.1.7.2l.2.1.2.1.6.3c.1.1.2.1.3.2l.2.1a9 9 0 0 1 1 .9l.2.2.1.1c.2.2.3.5.5.7s.2.4.3.5.1.4.2.5a6.37 6.37 0 0 1 .2.7c.1.3 0 .2 0 .2v.2a2.72 2.72 0 0 0-.3 1.4Z"
        fill="#f4f4f4"
      />
      <path
        d="M774.7 901.5h-27.2c-2.9 0-5.5-2.5-6.5-6.1l-.1-.5h40.4c-.9 3.9-3.6 6.6-6.6 6.6Z"
        fill="#f4f4f4"
      />
      <path
        d="m746.5 895 29-.1a.2.2 0 1 0 0-.4l-29 .1a.22.22 0 0 0-.2.2ZM777.7 875.2l-.3 3v.4c0 .1.3.2.4 0l.3-3v-.4c-.1-.2-.4-.2-.4 0ZM776.3 889.5l-.3 2.8v.4a.15.15 0 1 0 .3 0l.3-2.8v-.4a.15.15 0 0 0-.3 0Z"
        fill="#d8d8d8"
      />
      <path
        d="M136.5 608.5c-2.5-15.7-1.1-31.5.9-47 .5-3.9 1-7.8 1.6-11.6a80.65 80.65 0 0 1 2.1-10.9c1.9-6.9 5.4-12.9 9.5-18.5a179.52 179.52 0 0 1 16.1-18.8 2.58 2.58 0 0 0 .3-3.3 2.12 2.12 0 0 0-3-.5l-.1.1a193.18 193.18 0 0 0-15.2 17.4c-4.4 5.7-8.4 11.8-10.8 18.8-2.6 7.4-3.4 15.5-4.4 23.3-1.1 8-2 16-2.5 24a128.62 128.62 0 0 0 1.2 27.7 2.26 2.26 0 1 0 4.5-.5l-.2-.2Z"
        fill="#a7c16f"
      />
      <path
        d="M169.9 462.6c-2.9-3.4-9.9-4.2-14.7-1.2-8.5 5.2-12.1 23.8-8.6 25.4 1.5.7 7-6.1 8.5-4.9s-5.2 7-5.1 10.4c.1 4.5 5.3 8.7 7.2 8.5 2.6-.2 4.8-10.1 7.4-9 1.9.9-4.6 7-4.2 10 .4 2.3 11.5 8 12.9 7.5 4-1.4 3.7-8.6 5.2-8.2 2.1.5-1.1 6.1 0 9.1 1.1 2.8 3.4 2.9 8.4 4.9 8.2 3.1 8.6 7 10.7 6.8 1-.1 4.4-9.1 2.1-14.4-1.3-2.9-4.4-5.6-4.1-6.3.6-1.7 3.1 1 4.2.8 2.1-.5 3.9-9.9 2.2-12.3-2-2.7-6.6-4.1-5.3-5.8 1.1-1.4 4.7 1.5 5.8.8 2-1.4 2.2-7.3 0-10.8-1.4-2.1-8.4-4.1-7.6-6 .6-1.3 5.4 1.8 6.5.4 2.1-3-6.6-19.8-17.2-18.4-13.2 1.8-14.3 12.7-14.3 12.7Z"
        fill="#a7c16f"
      />
      <path
        d="M169.7 463.2c4.8 6.8 8.6 14.2 12.4 21.5s7.9 14.8 10.6 22.7a86.61 86.61 0 0 1 3.5 14.2.57.57 0 0 0 .7.4.66.66 0 0 0 .4-.5 91.9 91.9 0 0 0-7.7-24.5c-1.8-3.8-3.8-7.5-5.7-11.3s-3.9-7.6-6-11.4"
        fill="#758459"
      />
      <path
        d="M141.1 611.8c-2.5-15.7-1.1-31.5.9-47 .5-3.9 1-7.8 1.6-11.6a79.23 79.23 0 0 1 2.1-10.8c1.9-6.9 5.4-12.9 9.5-18.5a179.52 179.52 0 0 1 16.1-18.8 2.58 2.58 0 0 0 .3-3.3 2.12 2.12 0 0 0-3-.5l-.1.1a193.18 193.18 0 0 0-15.2 17.4c-4.4 5.7-8.4 11.8-10.8 18.8-2.6 7.4-3.4 15.5-4.4 23.3-1.1 8-2 16-2.5 24a128.62 128.62 0 0 0 1.2 27.7 2.26 2.26 0 1 0 4.5-.5c-.2-.1-.2-.2-.2-.3Z"
        fill="#a7c16f"
      />
      <path
        d="M174.5 466c-2.9-3.4-9.9-4.2-14.7-1.2-8.5 5.2-12.1 23.8-8.6 25.4 1.5.7 7-6 8.5-4.9s-5.2 7-5.1 10.4c.1 4.5 5.3 8.7 7.2 8.5 2.6-.2 4.8-10.1 7.4-9 1.9.9-4.6 7-4.2 10 .4 2.3 11.5 8 12.9 7.5 4-1.4 3.7-8.6 5.2-8.2 2.1.5-1.1 6.1 0 9.1 1.1 2.8 3.4 2.9 8.4 4.8 8.2 3.2 8.6 7 10.8 6.8 1.1-.1 4.4-9.1 2.1-14.4-1.3-2.9-4.4-5.6-4.1-6.3.6-1.7 3.1 1 4.2.8 2.1-.5 3.9-9.9 2.2-12.3-2-2.7-6.6-4.1-5.3-5.8 1.1-1.4 4.7 1.5 5.8.8 2-1.4 2.2-7.3 0-10.8-1.4-2.1-8.4-4.1-7.6-6 .6-1.3 5.4 1.8 6.5.4 2.2-3-6.6-19.8-17.2-18.4-13.3 1.9-14.4 12.8-14.4 12.8Z"
        fill="#a7c16f"
      />
      <path
        d="M174.2 466.5c4.8 6.8 8.6 14.2 12.4 21.5s7.9 14.8 10.6 22.7a86.61 86.61 0 0 1 3.5 14.2.57.57 0 0 0 .7.4.66.66 0 0 0 .4-.5 91.9 91.9 0 0 0-7.7-24.5c-1.8-3.8-3.8-7.5-5.7-11.3s-3.9-7.6-6-11.4a128.06 128.06 0 0 0-7.2-11.8c-.5-.5-1.4.2-1 .7Z"
        fill="#bdd384"
      />
      <path
        d="M125 595.1c0-15.9-3.9-31.3-8.3-46.3-1.1-3.8-2.2-7.5-3.4-11.2a81.18 81.18 0 0 0-3.8-10.4 57.83 57.83 0 0 0-12.3-16.7 159.91 159.91 0 0 0-18.9-16 2.61 2.61 0 0 1-.8-3.3 2.09 2.09 0 0 1 2.9-.9h.1a179 179 0 0 1 17.8 14.8 69.18 69.18 0 0 1 13.6 16.8c3.7 6.9 5.8 14.8 8 22.3s4.5 15.4 6.2 23.3a133.3 133.3 0 0 1 3.2 27.5 2.22 2.22 0 0 1-2.2 2.2 2 2 0 0 1-2.1-2.1Z"
        fill="#a7c16f"
      />
      <path
        d="M69.2 456.4c2.3-3.8 9.1-5.7 14.4-3.5 9.3 3.8 15.7 21.6 12.5 23.8-1.4 1-7.9-4.9-9.2-3.5s6.3 6.1 6.7 9.5c.6 4.5-3.9 9.4-5.8 9.6-2.6.2-6.3-9.3-8.7-7.8-1.8 1.1 5.7 6.2 5.7 9.2 0 2.4-10.1 9.7-11.6 9.5-4.2-.7-5-7.9-6.5-7.2-2 .9 2.1 5.9 1.4 9s-2.8 3.4-7.5 6.1c-7.6 4.4-7.4 8.3-9.6 8.4-1 .1-5.8-8.3-4.3-13.9.8-3 3.5-6.2 3.1-6.9-.9-1.6-2.9 1.5-4 1.5-2.2-.1-5.5-9.2-4.1-11.8 1.6-3 5.9-5.1 4.4-6.6-1.3-1.2-4.4 2.2-5.6 1.7-2.2-1.1-3.3-6.9-1.7-10.6 1-2.3 7.7-5.4 6.6-7.2-.8-1.2-5.1 2.7-6.3 1.4-2.6-2.6 3.3-20.6 14.1-20.8 13.1-.5 16 10.1 16 10.1Z"
        fill="#a7c16f"
      />
      <path
        d="M69.5 456.9c-3.7 7.4-6.2 15.4-8.8 23.2s-5.5 15.8-6.9 24.1a101.56 101.56 0 0 0-1.3 14.6.56.56 0 0 1-.6.5c-.2 0-.4-.2-.5-.5a95.24 95.24 0 0 1 3.8-25.4c1.2-4 2.6-8 3.9-12s2.7-8.1 4.1-12.2a118.91 118.91 0 0 1 5.3-12.8c.3-.7 1.3-.2 1 .5Z"
        fill="#bdd384"
      />
      <path
        d="M189.2 775.4h5.7l-28.8-129.7h6.8a3.1 3.1 0 0 0 3.3-2.7v-3.6a3 3 0 0 0-3.3-2.7H97.1a3.1 3.1 0 0 0-3.3 2.7v3.6a3 3 0 0 0 3.3 2.7h7.3L75.7 775.4h5.7l7.1-32.1h93.6Zm-28.7-129.7 6.9 30.9h-64l6.8-30.9Zm-70.9 92.6 12.6-56.8h66.2l12.6 56.8Z"
        fill="#8e4910"
      />
      <path
        d="M117.9 476.6c-.9 17.8 1.2 35.5 4 53s6.2 34.9 8.1 52.5a227.83 227.83 0 0 1 1.3 29.8c-.1 2.8 4.2 2.8 4.3 0 .6-17.8-1.7-35.5-4.5-53s-6.3-34.9-8-52.5a196.57 196.57 0 0 1-.9-29.7 2.11 2.11 0 0 0-2.1-2.1 2 2 0 0 0-2.2 2ZM81.9 555.2c14.1 14.1 28.6 29.1 35.6 48.2a60.68 60.68 0 0 1 3.6 15.7 2.27 2.27 0 0 0 2.1 2.2 2.14 2.14 0 0 0 2.1-2.2c-2-21-14.1-38.9-28-54-4-4.4-8.2-8.7-12.5-12.9-1.9-2-4.9 1.1-2.9 3Z"
        fill="#8ba05f"
      />
      <path
        d="M71.4 510.9c3.2-5.1 12.4-7.4 19.4-4.4 12.4 5.4 20.6 29.4 16.2 32.3-1.9 1.2-10.5-6.8-12.3-5s8.3 8.4 8.8 12.9c.6 6-5.5 12.6-8 12.7-3.5.2-8.3-12.6-11.5-10.7-2.4 1.5 7.5 8.5 7.4 12.5 0 3.2-13.8 12.8-15.9 12.4-5.6-1.1-6.5-10.7-8.5-9.9-2.7 1.1 2.7 7.9 1.7 12.2-.9 4-3.9 4.5-10.2 8-10.3 5.7-10.1 10.9-13.1 11-1.4.1-7.6-11.3-5.4-18.8 1.2-4 4.8-8.2 4.3-9.2-1.1-2.2-4 2-5.4 1.9-2.9-.2-7.1-12.5-5.2-16 2.2-4 8.1-6.7 6-8.8-1.7-1.7-6 2.9-7.6 2.1-3-1.5-4.2-9.3-2-14.3 1.4-3.1 10.5-7 9-9.5-1-1.7-6.9 3.5-8.5 1.7-3.4-3.6 5-27.7 19.6-27.7 17.6.3 21.2 14.6 21.2 14.6Z"
        fill="#8ba05f"
      />
      <path
        d="M70.7 511c-5.2 9.9-8.8 20.5-12.5 30.9-3.9 10.9-8 21.8-10.1 33.2a126.35 126.35 0 0 0-2 19.3.56.56 0 0 0 .6.5c.2 0 .4-.2.5-.5a125.32 125.32 0 0 1 5.7-33.8c1.7-5.5 3.7-10.9 5.6-16.3 1.8-5.2 3.7-10.4 5.6-15.6a175.32 175.32 0 0 1 7.5-17.2c.4-.6-.6-1.1-.9-.5ZM92.9 544.2a56 56 0 0 0-18.3-17.3.52.52 0 0 0-.7.3.48.48 0 0 0 .2.6 54.19 54.19 0 0 1 18 17c.3.5 1.2 0 .8-.6ZM41.7 558.8a48.87 48.87 0 0 1 7-9.4c.5-.5-.3-1.3-.8-.8a48.19 48.19 0 0 0-7.2 9.6.52.52 0 0 0 .3.7.49.49 0 0 0 .7-.1Z"
        fill="#a8ba7b"
      />
      <path
        d="M160.2 495.1c-2.4-2.8-6.8-4.9-6.7-5.9.1-2.2 3.9.2 5-.4 2.2-1.2 1.3-12.5-1.4-14.6-3.2-2.4-8.8-2.5-7.9-4.9.7-1.9 5.8.2 6.8-1 1.9-2.3.2-9-3.4-12.2-2.2-2-10.9-2-10.6-4.5.2-1.7 6.7.4 7.4-1.6 1.5-4.1-13.7-20.5-25.4-15.4-14.1 6.1-12 18.9-12 18.9-4.3-3-12.5-1.6-17.1 3.3-8 8.6-6.3 30.9-1.7 31.6 2 .3 6-9.1 8.1-8.3 1.9.8-3.7 9.6-2.5 13.4 1.6 5.1 8.8 8.2 10.9 7.4 2.9-1.1 2.3-13 5.5-12.6 2.4.4-3 9.5-1.6 12.7 1.1 2.5 15.6 5.5 17.1 4.5 4.1-2.8 1.5-10.9 3.4-10.9 2.6-.1.6 7.3 2.9 10.4 2.1 2.9 4.7 2.3 11 2.9 10.3 1 11.9 5.2 14.4 4.3 1.2-.5 2.2-11.8-2.2-17.1Z"
        fill="#8ba05f"
      />
      <path
        d="M112.1 454.1c7.8 6.3 14.5 13.7 21.3 21s13.9 14.6 19.5 23a109.33 109.33 0 0 1 7.9 14.2c.3.6 1.2.1.9-.5a106.93 106.93 0 0 0-15.8-24.5c-3.3-3.9-6.8-7.5-10.2-11.2s-6.9-7.4-10.4-11a136.12 136.12 0 0 0-12.4-11.6c-.6-.6-1.4.1-.8.6Z"
        fill="#a8ba7b"
      />
      <path
        d="M141.2 617.7c0-14.3 3.7-28.2 8-41.7 1.1-3.4 2.1-6.8 3.3-10.1a74.54 74.54 0 0 1 3.6-9.3 52.67 52.67 0 0 1 11.9-15.1 157.68 157.68 0 0 1 18.2-14.4 2.23 2.23 0 0 0 .8-2.9 2.14 2.14 0 0 0-2.9-.8 170 170 0 0 0-17.1 13.3c-5 4.4-9.8 9.3-13.1 15.2-3.6 6.2-5.6 13.3-7.8 20.1s-4.4 13.9-6 21a103.28 103.28 0 0 0-3 24.8c-.1 2.6 4.2 2.6 4.1-.1Z"
        fill="#8ba05f"
      />
      <path
        d="M181.1 513.4c-2.3-3.8-9.1-5.7-14.4-3.5-9.2 3.8-15.7 21.6-12.5 23.8 1.4 1 7.9-4.9 9.2-3.5s-6.3 6.1-6.7 9.5c-.6 4.5 3.9 9.4 5.7 9.6 2.6.2 6.4-9.2 8.7-7.7 1.8 1.1-5.7 6.2-5.7 9.2 0 2.4 10.1 9.7 11.6 9.5 4.1-.7 5-7.9 6.5-7.2 2 .9-2.1 5.8-1.4 9 .6 3 2.8 3.4 7.5 6.1 7.6 4.4 7.4 8.2 9.6 8.4 1 .1 5.8-8.3 4.3-13.9-.8-3-3.5-6.2-3.1-6.9.9-1.6 2.9 1.5 4 1.5 2.2-.1 5.4-9.2 4.1-11.8-1.6-3-5.9-5.1-4.4-6.6 1.3-1.2 4.4 2.3 5.6 1.7 2.2-1.1 3.3-6.8 1.7-10.6-1-2.3-7.7-5.4-6.6-7.2.8-1.2 5.1 2.7 6.3 1.4 2.6-2.7-3.3-20.6-14.1-20.8-13.1-.6-15.9 10-15.9 10Z"
        fill="#8ba05f"
      />
      <path
        d="M180.8 513.9c3.7 7.4 6.2 15.4 8.8 23.2s5.5 15.8 6.9 24.1a89 89 0 0 1 1.2 14.6.56.56 0 0 0 .6.5c.2 0 .4-.2.5-.5a95.24 95.24 0 0 0-3.8-25.4c-1.2-4.1-2.6-8.1-3.9-12.1s-2.7-8.1-4.1-12.2a118.91 118.91 0 0 0-5.3-12.8c-.3-.6-1.2-.1-.9.6Z"
        fill="#a8ba7b"
      />
      <path
        d="M153.5 636.7h-40l-5.3-39.6a1.81 1.81 0 0 1 1.6-2h47.3a1.79 1.79 0 0 1 1.8 1.8v.2Z"
        fill="url(#d)"
      />
      <path fill="#f4e2ca" d="m328 357.5-14-6v-2l13.9 5.7.1 2.3z" />
      <path
        d="M723.2 599.5s3.5-11 12.3-5.5 8.9 13.5 4 17.2-17.4.7-17.5-4.3 1.2-7.4 1.2-7.4Z"
        fill="#a32b28"
      />
      <path
        d="M709.8 636.4s.9 35.2-1.7 47.1c.2-.4 3 0 3 0s5.6-24.9 5.1-32.1c.9.9 1.5 6.3 2.4 8.8s7.3-1.7 7.3-1.7 6.1-40.9-13.4-48.8-2.7 26.7-2.7 26.7Z"
        fill="#a02410"
      />
      <path
        d="M735.8 609.9s7.9 13 5.8 32.3a7.67 7.67 0 0 1-2.6 5l-13 11.3-7.9-9.8 2.4-19.1ZM682.8 614.4s7.7 11.2 15.5 12.7 12.8 16.5 12.8 16.5l2.5-16.5-12.9-12.2Z"
        fill="#a02410"
      />
      <path
        d="M729.6 744.6c-1.1-2.5-8.4-11.4-10.3-27.4-2.5-20.1 4.5-30.6 8-39.7l-2.7-1.9c-7.5 12.8-12.8 32-12.4 48.7-15 6.7-23.2 1.3-26.2-1.7 1.2-14.5 4.2-33 8.7-42.2l-3.3 1.5a149.91 149.91 0 0 0-8.6 44.7 13.94 13.94 0 0 0 .3 4.1l-.6 4 9.6 8.2 16.2 4.6 6.8-9c4.6 6.1 15.3 7.9 14.5 6.1ZM683.1 767s23.9-2.5 57.5 10.8l-.7 25.8-39.4-7.6-22.6-4.4c.1-.1 5.3-19.1 5.2-24.6Z"
        fill="#26211d"
      />
      <path d="M678 791.5s25 14 62 12l-30.7-17Z" fill="#26211d" />
      <path
        d="m677.6 651 .4 1.6a3.09 3.09 0 0 0 .2.8 1.58 1.58 0 0 1 .1.4c5.3.1 9.5-5.4 8.2-4.7a15.32 15.32 0 0 1-8.9 1.9Z"
        fill="#fff"
      />
      <path
        d="M314.3 377.9s7.3 10.6 23.5 9.6l-.3 3s-17.5 0-23.5-9.4Z"
        fill="#9e695c"
        opacity={0.2}
        style={{
          isolation: "isolate",
        }}
      />
      <circle
        cx={334}
        cy={357.5}
        r={6}
        fill="none"
        stroke="#f4e2ca"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <circle
        cx={351.5}
        cy={359}
        r={5.5}
        fill="none"
        stroke="#f4e2ca"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        fill="#f4e2ca"
        d="m339.975 358.415.082-1.898 5.994.258-.081 1.898z"
      />
      <path
        d="M200 451.4c13.7-8.2 47.5-23.5 95.5-11.5a12.17 12.17 0 0 1 8.5 7.4c4.9 12.7 16 44.3 17.1 71.9a8.74 8.74 0 0 1-7 8.8c-19.8 4.1-73 18.3-79.7 20.4-11.6 3.6-26.3-65.7-37.3-86.8a7.71 7.71 0 0 1 2.9-10.2Z"
        fill="#93529e"
      />
      <path
        d="M224 417.9a121.17 121.17 0 0 1 12.9 5.4 53.27 53.27 0 0 1 11.5 7.3c.3.2.7-.2.4-.4a59.28 59.28 0 0 0-11.7-7.4 123.46 123.46 0 0 0-13-5.5.32.32 0 0 0-.1.6ZM249.7 430.5a13.35 13.35 0 0 1 .1-10.2c.1-.3-.4-.6-.5-.3a13.91 13.91 0 0 0-.2 10.6c.2.4.7.3.6-.1Z"
        fill="#757575"
        opacity={0.5}
      />
      <g clipPath="url(#e)">
        <path
          d="m257.2 754.1-4.6-25.9-1.5-8.4h-73.5s-4.3 27.6-4.8 37.6a25.85 25.85 0 0 0 24.6 27.1h34.3a25.91 25.91 0 0 0 25.9-25.9 17.15 17.15 0 0 0-.4-4.5Z"
          fill="#2e2122"
        />
        <path
          d="M173.1 754.3a22.61 22.61 0 0 1 7.3-4.4 12.49 12.49 0 0 1 8.1 0c2.6.8 5 2 7.6 2.8a14 14 0 0 0 8.1.3c2.8-.7 5.4-2.1 8.1-3a17.17 17.17 0 0 1 8.7-.7c5.6 1.1 10.2 5.6 16.2 3.8 3.1-.9 5.7-2.8 8.9-3.5a19.27 19.27 0 0 1 10.1.6c1.6.5 2.3-2 .7-2.6a20.62 20.62 0 0 0-9.2-1 24.71 24.71 0 0 0-8.3 2.8 16.91 16.91 0 0 1-4.3 1.5 10 10 0 0 1-4.2-.6c-2.7-1-5.1-2.5-7.9-3.2a19.92 19.92 0 0 0-9.4-.1c-2.8.7-5.4 2.1-8.2 3a12.75 12.75 0 0 1-8.4.2c-2.7-.8-5.2-2.1-7.9-2.8-6.6-1.9-12.7.9-17.6 5.2-1.5.9.4 2.7 1.6 1.7ZM174.7 769.7a22.61 22.61 0 0 1 7.3-4.4 12.49 12.49 0 0 1 8.1 0c2.6.8 5 2 7.6 2.7a14 14 0 0 0 8.1.3c2.8-.7 5.4-2.1 8.1-3a17.17 17.17 0 0 1 8.7-.7c5.6 1.1 10.2 5.6 16.2 3.8 3.1-.9 5.7-2.8 8.9-3.5a19.33 19.33 0 0 1 10.1.6c1.6.6 2.3-2 .7-2.6a20.62 20.62 0 0 0-9.2-1 24.71 24.71 0 0 0-8.3 2.8 15.67 15.67 0 0 1-4.3 1.5 10 10 0 0 1-4.2-.6c-2.7-1-5.1-2.5-7.9-3.2a19.92 19.92 0 0 0-9.4-.1c-2.8.7-5.4 2.1-8.2 3a12.75 12.75 0 0 1-8.4.2c-2.7-.8-5.2-2.1-7.9-2.8-6.6-1.9-12.7.9-17.6 5.2-1.6 1 .3 2.9 1.6 1.8Z"
          fill="#f8d1bf"
          opacity={0.59}
        />
      </g>
      <path
        d="M195.3 728.4h42l1.1-8.6H190Z"
        fill="#703f31"
        opacity={0.49}
        style={{
          isolation: "isolate",
        }}
      />
      <path
        d="M180.6 716.8c1.7-5.2 8-7.4 13.1-6.7s8.6 5.1 10.3 9.8h2.8c-2-6-6.4-11.7-13.1-12.4-6.3-.7-13.6 2.2-15.6 8.7-.6 1.5 2 2.2 2.5.6Z"
        fill="#8ba05f"
      />
      <path
        d="M191.3 694.8a66.78 66.78 0 0 1 10.4 11.5 51.94 51.94 0 0 1 6.3 13.5h2.8A53.73 53.73 0 0 0 204 705a72.38 72.38 0 0 0-10.8-12c-1.3-1.2-3.2.7-1.9 1.8ZM217.5 719.8a75.21 75.21 0 0 1 4.4-15.4 26.11 26.11 0 0 1 4.2-7.2 52 52 0 0 1 6.1-6.3c1.3-1.1-.6-3-1.9-1.9a54.26 54.26 0 0 0-6.2 6.5 31.41 31.41 0 0 0-4.4 7.5 80.76 80.76 0 0 0-4.8 16.8ZM245.3 712.2a25.37 25.37 0 0 0-17.6.1 17.69 17.69 0 0 0-7 4.7 17.26 17.26 0 0 0-1.9 2.8h3.1a5.8 5.8 0 0 1 1-1.2 16.14 16.14 0 0 1 6.3-4 23.24 23.24 0 0 1 15.4.2c1.6.5 2.3-2 .7-2.6Z"
        fill="#8ba05f"
      />
      <path
        d="M229.9 694.8a17.32 17.32 0 0 1 0-24.4l6.1-6.1a17.32 17.32 0 0 1 24.4 0 17.32 17.32 0 0 1 0 24.4l-6.1 6.1a17.14 17.14 0 0 1-24.4 0ZM212.3 676.4q1 21.3 2.4 42.6h2.7q-1.35-21.3-2.4-42.6c-.1-1.7-2.8-1.7-2.7 0Z"
        fill="#8ba05f"
      />
      <path
        d="M213.4 678.4a17.24 17.24 0 0 1-16.4-18.1l.4-8.6a17.31 17.31 0 0 1 18.1-16.4 17.24 17.24 0 0 1 16.4 18.1l-.4 8.6a17.3 17.3 0 0 1-18.1 16.4ZM170.6 704.8a75 75 0 0 1 13.3-2 25.85 25.85 0 0 1 12.3 1.8 50.09 50.09 0 0 1 10.2 6.1c3.1 2.3 6.1 5.1 6.4 9.1h2.7c-.6-7.1-6.9-11.1-12.4-14.5a35.72 35.72 0 0 0-9.3-4.3 33.26 33.26 0 0 0-10.9-.7 78.77 78.77 0 0 0-12.9 2c-1.8.3-1.1 2.9.6 2.5Z"
        fill="#8ba05f"
      />
      <path
        d="M164.8 664.5a17.32 17.32 0 0 1 24.4 0l6.1 6.1a17.32 17.32 0 0 1 0 24.4 17.32 17.32 0 0 1-24.4 0l-6.1-6.1c-9.5 0-17.2-2.7-17.2-12.2s7.6-17.2 17.2-12.2Z"
        fill="#8ba05f"
      />
      <path
        d="M129.9 709.5a17.3 17.3 0 0 1 14.9-19.3l8.6-1.1a17.3 17.3 0 0 1 19.3 14.9 17.3 17.3 0 0 1-14.9 19.3l-8.6 1.1a17.23 17.23 0 0 1-19.3-14.9Z"
        fill="#8ba05f"
      />
      <path
        d="M214.4 669.4a106.92 106.92 0 0 1-.7-26.5c.1-.8-1.2-.8-1.3 0a105.31 105.31 0 0 0 .8 26.9c.1.8 1.4.4 1.2-.4ZM169.8 670.1c3.7 6.4 9.4 11.3 14.9 16.1.6.6 1.6-.4.9-.9-5.5-4.7-11.1-9.5-14.7-15.9a.56.56 0 0 0-.9-.1.78.78 0 0 0-.2.8Z"
        fill="#a8ba7b"
      />
      <path
        d="M237.1 686a97 97 0 0 1 15.5-18.9c.6-.6-.3-1.5-.9-1a95.67 95.67 0 0 0-15.7 19.1c-.5.8.7 1.5 1.1.8Z"
        fill="#8ba05f"
      />
      <path
        d="M137 710.8a83.89 83.89 0 0 1 25.1-6.6c.8-.1.9-1.4 0-1.3a85.6 85.6 0 0 0-25.8 6.8c-.7.3-.1 1.5.7 1.1ZM178.9 678.9a31.49 31.49 0 0 1-.4-8.1.65.65 0 1 0-1.3 0 33.91 33.91 0 0 0 .5 8.4.6.6 0 0 0 .8.4c.2 0 .4-.3.4-.7ZM177.1 684.3a7.44 7.44 0 0 1 2.6-.2l2.8.3a.66.66 0 0 0 .6-.7c0-.3-.3-.5-.6-.6l-2.9-.3a6.72 6.72 0 0 0-2.8.3.75.75 0 0 0-.5.8.68.68 0 0 0 .8.4ZM213.2 655.3a47.59 47.59 0 0 1 5.4-9.9c.5-.7-.7-1.4-1.1-.7a50.24 50.24 0 0 0-5.5 10.2.63.63 0 1 0 1.2.4ZM205.4 659.8a18.7 18.7 0 0 1 6.7 5.1.56.56 0 0 0 .9 0 .67.67 0 0 0 0-1 19.15 19.15 0 0 0-7-5.3.65.65 0 0 0-.9.2 1 1 0 0 0 .3 1Z"
        fill="#a8ba7b"
      />
      <path
        d="M158.5 703.9a40.62 40.62 0 0 1-3.8 7.5c-.5.7.7 1.4 1.1.7a38.7 38.7 0 0 0 3.9-7.9.62.62 0 0 0-.5-.8c-.3-.1-.6.1-.7.5ZM140.1 702.3a15.54 15.54 0 0 0 2.3.5 14.27 14.27 0 0 1 2.2.8l2.3 1.1 1.1.5c.4.2.7.4 1.1.3a.63.63 0 0 0 .5-.6.76.76 0 0 0-.2-.5.75.75 0 0 0-.8-.1.56.56 0 0 0-.1.9.78.78 0 0 0 .8.2l-.8-.1c-.1-.2-.1-.3-.2-.5l.5-.7h.3a4.67 4.67 0 0 1-1-.5l-1.1-.5-2.2-1.1a8.64 8.64 0 0 0-2.1-.7 17.42 17.42 0 0 1-2.2-.5.62.62 0 0 0-.8.5 1 1 0 0 0 .4 1Z"
        fill="#a8ba7b"
      />
      <path
        d="M179.3 716.2a17.2 17.2 0 0 1 17.2 17.2v8.6a17.2 17.2 0 0 1-17.2 17.2 17.2 17.2 0 0 1-17.2-17.2v-8.6a17.2 17.2 0 0 1 17.2-17.2Z"
        fill="#8ba05f"
      />
      <path
        d="M176.3 730a103.12 103.12 0 0 0 2.1 24.8c.2.8 1.4.5 1.3-.3a106.26 106.26 0 0 1-2-24.5.7.7 0 0 0-1.4 0Z"
        fill="#a8ba7b"
      />
      <path
        d="M176.1 732.8a12.75 12.75 0 0 0-5.2 8 .67.67 0 0 0 1.3.3 11.25 11.25 0 0 1 4.6-7.2.65.65 0 0 0 .2-.9.65.65 0 0 0-.9-.2ZM177.7 747.3a16.18 16.18 0 0 1 7.2 3.8c.6.6 1.6-.4.9-.9a18 18 0 0 0-7.8-4.2c-.8-.1-1.2 1.1-.3 1.3Z"
        fill="#a8ba7b"
      />
      <path
        d="M272.8 744.6a17.32 17.32 0 0 1-24.4 0l-6.1-6.1a17.32 17.32 0 0 1 0-24.4 17.32 17.32 0 0 1 24.4 0l6.1 6.1c8 5.1 11.9 13.4 6.7 21.5-1.4 2.1-3.1 3.9-6.7 2.9Z"
        fill="#8ba05f"
      />
      <path
        d="M253.1 721a42.54 42.54 0 0 1 14.9 14c.5.7 1.6 0 1.1-.7a43.39 43.39 0 0 0-15.3-14.5c-.7-.4-1.4.7-.7 1.2Z"
        fill="#a8ba7b"
      />
      <path
        d="M256 722.6c-.2 4.2-.3 8.4-.2 12.6a.66.66 0 0 0 .7.6c.3 0 .5-.3.6-.6-.1-4.2 0-8.4.2-12.6.1-.9-1.3-.9-1.3 0ZM262.7 727.8c3.5.3 6.9-.9 10.4-.8a.65.65 0 1 0 0-1.3c-3.5-.1-6.9 1.1-10.4.8-.8-.1-.8 1.2 0 1.3Z"
        fill="#a8ba7b"
      />
      <path
        d="M289 455.7s26.3 24.2 0 46.8M293.4 452.8s4.5 4.7 3.6 9.2M297.1 453.3s.6 3.3 0 5"
        fill="none"
        stroke="#7c4b87"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M295.7 512.6s-1 14.1-54.3 30"
        fill="none"
        stroke="#7c4b87"
        strokeLinecap="round"
        strokeMiterlimit={10}
      />
      <path
        d="M256.3 440c7.4 3.3 15.4 4.5 18 5.6 8.1 3.5 9.7 5.7 16.3 10.5 19.7 14.4 15 22.5 9.7 21.2-2.4-.6-20.1-10.8-21.1-9.7s12.4 13.1 10.6 14.5c-2.2 1.8-7.5-5.4-20-13.4-12.2-7.8-15.7-10.4-18.5-14.6Z"
        fill="#dba795"
      />
      <path
        d="M208.2 445.8c12.5 6.5 49.1 14 49.1 14 4.9-3.8 5.9-17.4 5.9-17.4-18-16.5-20.7-14-23-14.5-3.5-.8-15.2-3.4-24.5 4.1-1.6 1.5-7.5 13.8-7.5 13.8Z"
        fill="#333"
      />
      <path
        d="M533.9 370h-.4l1-7.6c1.3-13.2-9.4-19.9-19.9-19.9-9.6 0-18.6 3.7-19.8 15.7a24.37 24.37 0 0 0 0 5.4l.6 6.3h-.2a4.27 4.27 0 0 0-4.1 4.5 4.33 4.33 0 0 0 4.1 4.1h.3c1.1 9.8 6.8 20.6 18.7 20.6 12.6 0 18-10.7 19.1-20.6h.5a4.27 4.27 0 0 0 4.3-4.3 4.23 4.23 0 0 0-4.2-4.2Z"
        fill="#e8a18e"
      />
      <path
        d="M314 438.5a22.7 22.7 0 0 0-13.3 4.3 182.93 182.93 0 0 1 14.3 39.7c11.7-1.1 22-9 22-21a23 23 0 0 0-23-23Z"
        fill="#fffd54"
      />
      <path
        d="M335 470s7 1.5 14.5 2.5c0 0-8.9 6.9-8.7 11.9s6.1 36.1 5.1 37.6-21 3.4-21 3.4a22.38 22.38 0 0 0-4.3-3.3s1.4-16.7-5.6-39.7a23.88 23.88 0 0 0 20-12.4Z"
        fill="#b9271a"
      />
      <path
        d="M514.6 377.8c-.2.8-.5 1.6-.7 2.4a10.93 10.93 0 0 0-.5 1.7 1.39 1.39 0 0 0 .2 1.1 1.79 1.79 0 0 0 1.4.4 2.65 2.65 0 0 0 1.8-1.1c.2-.2-.2-.4-.4-.2a1.92 1.92 0 0 1-1.8.9c-.4-.1-.8-.2-.8-.7a4.71 4.71 0 0 1 .4-1.7c.3-.9.5-1.8.8-2.6.1-.3-.3-.5-.4-.2Z"
        fill="#e58c7a"
      />
      <path
        d="M510.1 366.5c.3-.8-.1-1.1-1.3-1.3a8.89 8.89 0 0 0-3.6.4c-2.3.8-3.3 3-2.6 2.6a11 11 0 0 1 4.4-1.5c1.3-.1 2.9.3 3.1-.2ZM519.2 366.6c-.3-.8.1-1.1 1.3-1.3a8.89 8.89 0 0 1 3.6.4c2.3.8 3.3 2.9 2.7 2.5a9.9 9.9 0 0 0-4.4-1.4c-1.4-.2-3.1.3-3.2-.2Z"
        fill="#713a39"
      />
      <ellipse cx={507} cy={374.5} rx={1} ry={2} fill="#564444" />
      <ellipse cx={523} cy={374.5} rx={1} ry={2} fill="#564444" />
      <g fill="#352d2d">
        <path d="M535.4 372.5a2.59 2.59 0 0 0-1.1 1.4 4.08 4.08 0 0 0-.1 1.9c0 .2.4.1.4-.1a3.28 3.28 0 0 1 .1-1.7 2.73 2.73 0 0 1 .9-1.2c.1-.1-.1-.4-.2-.3Z" />
        <path d="M534.5 374.3h.7a.1.1 0 0 1 .1.1v1l-.1.1a.19.19 0 0 0 0 .3.19.19 0 0 0 .3 0 1.31 1.31 0 0 0 .3-1 1 1 0 0 0-.7-.8 2.2 2.2 0 0 0-.8-.1c-.1 0-.2.1-.1.2s.1.2.2.1Z" />
      </g>
      <g fill="#352d2d">
        <path d="M493.5 372.8a2.73 2.73 0 0 1 .9 1.2 3.22 3.22 0 0 1 .1 1.7.21.21 0 0 0 .4.1 4.08 4.08 0 0 0-.1-1.9 3.6 3.6 0 0 0-1.1-1.4c-.2-.2-.3.1-.2.3Z" />
        <path d="M494.7 373.9a1.31 1.31 0 0 0-1.2.3 1.16 1.16 0 0 0-.2 1 .86.86 0 0 0 .3.6.21.21 0 0 0 .3-.3l-.1-.1c0-.1-.1-.1-.1-.2V374.9l.1-.1h.8c.1 0 .2 0 .2-.1s0-.2-.1-.2Z" />
      </g>
      <path
        d="M514.6 389.6c-2.8 0-4.5-1.1-5.1-2a.19.19 0 0 1 0-.3h.1s3 .2 4.9.2 5-.2 5-.2c.2 0 .3.1.2.2-.5.8-2.1 2.1-5.1 2.1Z"
        fill="#fff"
      />
      <path
        d="M474.6 473.3a138.59 138.59 0 0 1 1.7-23.2 48.39 48.39 0 0 1 3-10.5c1.5-3.3 2.8-6.6 4-10 .1-.5.9-.3.8.2a96.59 96.59 0 0 1-3.7 9.4 43.27 43.27 0 0 0-3.2 10.6 142.17 142.17 0 0 0-1.7 23.5.43.43 0 0 1-.4.4c-.3-.1-.5-.3-.5-.4ZM549.2 475.1a153.49 153.49 0 0 1-2.9-24.3c-.2-4.1-.1-8.1 0-12.2s0-8.6-3-11.8a.43.43 0 0 1 .6-.6c2.4 2.6 3.2 6.1 3.2 9.5.1 4.3-.2 8.7-.1 13a144.07 144.07 0 0 0 3 26.2c.1.5-.7.7-.8.2ZM485.9 514a48.17 48.17 0 0 1-3.1-7.4c-.1-.3.7-.4.8-.1a68.1 68.1 0 0 0 3.1 7.4c.1.3-.6.4-.8.1ZM496.7 512.8a23.74 23.74 0 0 1-5.2-16.1c0-.3.8-.3.8 0a23.54 23.54 0 0 0 5.1 15.9c.2.3-.5.5-.7.2Z"
        fill="#0e2651"
      />
      <path
        d="M237.5 687.7a78.93 78.93 0 0 1 12.7-15.5c.5-.5-.3-1.2-.8-.8a77.65 77.65 0 0 0-12.9 15.7c-.3.6.7 1.2 1 .6Z"
        fill="#a8ba7b"
      />
      <path
        d="M245.5 676.5a34 34 0 0 1-.2-7.8c.1-.7-1-.7-1.1 0a31.4 31.4 0 0 0 .2 8.1.57.57 0 0 0 .7.4.67.67 0 0 0 .4-.7ZM238.6 685.8a14.42 14.42 0 0 1 6.2.5.57.57 0 0 0 .7-.4.44.44 0 0 0-.4-.6 15.82 15.82 0 0 0-6.5-.5.54.54 0 0 0-.5.5.64.64 0 0 0 .5.5Z"
        fill="#a8ba7b"
      />
      <path
        d="M222.7 532.1s-1.2-16.7 1.1-23.2"
        fill="none"
        stroke="#7c4b87"
        strokeMiterlimit={10}
      />
      <path
        d="M203.9 462.9s16.2 19.2 19.1 37.9"
        fill="none"
        stroke="#7c4b87"
        strokeLinecap="round"
        strokeMiterlimit={10}
      />
      <path
        d="M541.8 362.6a22.44 22.44 0 0 1-3.2-6.6 70.2 70.2 0 0 0-3-8.8c-1.5-3.5-3.8-6.3-7.3-7.4-4.6-1.5-9.4-2.7-13.3 2.1a5.07 5.07 0 0 0-3.8-3c-5-1-12.6 0-16.1 7.4a63.76 63.76 0 0 0-3 8.7 23.36 23.36 0 0 1-3.7 7.6 8.76 8.76 0 0 0-1.5 7 17.19 17.19 0 0 0 3.7 8.1 16.85 16.85 0 0 1 2.4 4.6h2.5c-1.9-1-2.7-2.8-3-4.9-.4-2.3-.3-4.4 1.4-6.2a2.62 2.62 0 0 1 2.3-1h1.8a4.31 4.31 0 0 0 3.2-3.3c1.2-1.3.7-4.7.7-4.7.2-2.1.3-4.3.6-6.4.6-4.1 3.3-5.8 6.5-6.3a26.24 26.24 0 0 1 11.8.9c3.7 1.1 5.6 3 5.8 7.1.1 2.1.1 4.2.2 6.4a11 11 0 0 1 .2 1.8 6.26 6.26 0 0 0 .3 2.7c.7 2.5 2.2 3.6 5 3.6a3.4 3.4 0 0 1 1 .1l.3.1a.6.6 0 0 0 .4.1.47.47 0 0 0 .5-.5l-2.1-.2a3.84 3.84 0 0 1-4-2.5 8.61 8.61 0 0 1 0-3.2 2.17 2.17 0 0 0 .8 1.5 3.94 3.94 0 0 0 3.3 3h2.3a4.48 4.48 0 0 1 3.3 4.1 8.68 8.68 0 0 1-1.6 6.6 2.65 2.65 0 0 1-.5.6c-.3.2-.6.5-.9.7h2.4a20.75 20.75 0 0 1 3-5.7 20.13 20.13 0 0 0 2.5-5.1c.9-3.2.8-6.3-1.2-9Zm-13.5 6.4c0-.1-.1-.3-.1-.4Z"
        fill="#713a39"
        data-name="Layer 12"
      />
    </g>
  </svg>
  </StyledBackgroundWrapper>
  )
}

export default SvgRelationshipIntro